export const drillDownMaxLv = 11;
// export const drillDownTotalMaxLv = ['total', 'lv1', 'lv2', 'lv3', 'lv4', 'lv5', 'lv6', 'lv7', 'lv8', 'lv9', 'lv10', 'lv11'];
export const drillDownLv1MaxLv = ['lv1', 'lv2', 'lv3', 'lv4', 'lv5', 'lv6', 'lv7', 'lv8', 'lv9', 'lv10', 'lv11'];
// export const drillDownLv2MaxLv = ['lv2', 'lv3', 'lv4', 'lv5', 'lv6', 'lv7', 'lv8', 'lv9', 'lv10', 'lv11'];

//行固定
export const fixedRowsTop = 0;

//ヘッダー列
export const headerColKeys = [
  'no',
  "ISC", "ISN", "IMC", "IMN", "INM", "ICC", "ICN", "IBC", "IBN", "IJN", "ICD", "ICP", "IC1", "IC2", "ILI", "IPR",
];
//行ヘッダー列
export const rowHeaderColKeys = [
  'rowHeader1', 'rowHeader2', 'rowHeader3',
];
//期間列
export const termColKeys = [
  "T01", "T02", "T03", "T04", "T05", "T06", "T07", "T08", "T09", "T10",
  "T11", "T12", "T13", "T14", "T15", "T16", "T17", "T18", "T19", "T20",
  "T21", "T22", "T23", "T24", "T25", "T26", "T27", "T28", "T29", "T30",
  "T31",
];

export const headersCol = [
  {
    no : "No.",
    rowHeader1 : "項目", rowHeader2 : "項目", rowHeader3 : "項目",
    //以下に貼り付け
    ISC: "商品属性", ISN: "商品属性", IMC: "商品属性", IMN: "商品属性", INM: "商品属性", ICC: "商品属性", ICN: "商品属性", IBC: "商品属性", IBN: "商品属性", IJN: "商品属性", ICD: "商品属性", ICP: "商品属性", IC1: "商品属性", IC2: "商品属性", ILI: "商品属性", IPR: "商品属性",
    TTL: "合計",
    T01: "期間", T02: "期間", T03: "期間", T04: "期間", T05: "期間", T06: "期間", T07: "期間", T08: "期間", T09: "期間", T10: "期間",
    T11: "期間", T12: "期間", T13: "期間", T14: "期間", T15: "期間", T16: "期間", T17: "期間", T18: "期間", T19: "期間", T20: "期間",
    T21: "期間", T22: "期間", T23: "期間", T24: "期間", T25: "期間", T26: "期間", T27: "期間", T28: "期間", T29: "期間", T30: "期間",
    T31: "期間",
  },
  {
    no : "",
    rowHeader1 : "大項目", rowHeader2 : "中項目", rowHeader3 : "小項目",
    //以下に貼り付け
    ISC: "仕入先CD", ISN: "仕入先名", IMC: "メーカーCD", IMN: "メーカー名", INM: "商品名", ICC: "カテゴリCD", ICN: "カテゴリ名", IBC: "PB区分CD", IBN: "PB区分名", IJN: "JAN", ICD: "商品CD", ICP: "内容量", IC1: "BL入数", IC2: "CS入数", ILI: "賞味期間", IPR: "定価",
    TTL: "合計",
    T01: "%YM01%", T02: "%YM02%", T03: "%YM03%", T04: "%YM04%", T05: "%YM05%", T06: "%YM06%", T07: "%YM07%", T08: "%YM08%", T09: "%YM09%", T10: "%YM10%",
    T11: "%YM11%", T12: "%YM12%", T13: "%YM13%", T14: "%YM14%", T15: "%YM15%", T16: "%YM16%", T17: "%YM17%", T18: "%YM18%", T19: "%YM19%", T20: "%YM20%",
    T21: "%YM21%", T22: "%YM22%", T23: "%YM23%", T24: "%YM24%", T25: "%YM25%", T26: "%YM26%", T27: "%YM27%", T28: "%YM28%", T29: "%YM29%", T30: "%YM30%",
    T31: "%YM31%",
  },
];

export const headersRowMonthly = [
  {

    JJT: "受注", JJTK: "受注", JJP: "受注", JJPK: "受注", JJR: "受注", JJD: "受注", 
    JJQT: "受注", JJTQK: "受注", JJQP: "受注", JJPQK: "受注", JJQR: "受注", JJQD: "受注", 
    JKT: "欠品", JKTK: "欠品", JKP: "欠品", JKPK: "欠品", JKR: "欠品", JKD: "欠品", 
    JKQT: "欠品", JKTQK: "欠品", JKQP: "欠品", JKPQK: "欠品", JKQR: "欠品", JKQD: "欠品", 
    JRT: "欠品", JRP: "欠品", JRD: "欠品", 
    //欠品責任別
    KI1KQ: "欠品責任別", KI1KA: "欠品責任別", KI1KR: "欠品責任別", 
    KI2KQ: "欠品責任別", KI2KA: "欠品責任別", KI2KR: "欠品責任別", 
    KI3KQ: "欠品責任別", KI3KA: "欠品責任別", KI3KR: "欠品責任別", 
    //欠品区分別
    K10KQ: "欠品区分別(1.自社責)", K10KA: "欠品区分別(1.自社責)", K10KR: "欠品区分別(1.自社責)", 
    K11KQ: "欠品区分別(1.自社責)", K11KA: "欠品区分別(1.自社責)", K11KR: "欠品区分別(1.自社責)", 
    K12KQ: "欠品区分別(1.自社責)", K12KA: "欠品区分別(1.自社責)", K12KR: "欠品区分別(1.自社責)", 
    K13KQ: "欠品区分別(1.自社責)", K13KA: "欠品区分別(1.自社責)", K13KR: "欠品区分別(1.自社責)", 
    K14KQ: "欠品区分別(1.自社責)", K14KA: "欠品区分別(1.自社責)", K14KR: "欠品区分別(1.自社責)", 
    K15KQ: "欠品区分別(1.自社責)", K15KA: "欠品区分別(1.自社責)", K15KR: "欠品区分別(1.自社責)", 
    K16KQ: "欠品区分別(1.自社責)", K16KA: "欠品区分別(1.自社責)", K16KR: "欠品区分別(1.自社責)", 
    K17KQ: "欠品区分別(1.自社責)", K17KA: "欠品区分別(1.自社責)", K17KR: "欠品区分別(1.自社責)", 
    K19KQ: "欠品区分別(1.自社責)", K19KA: "欠品区分別(1.自社責)", K19KR: "欠品区分別(1.自社責)", 
    K20KQ: "欠品区分別(2.メーカー責)", K20KA: "欠品区分別(2.メーカー責)", K20KR: "欠品区分別(2.メーカー責)", 
    K21KQ: "欠品区分別(2.メーカー責)", K21KA: "欠品区分別(2.メーカー責)", K21KR: "欠品区分別(2.メーカー責)", 
    K22KQ: "欠品区分別(2.メーカー責)", K22KA: "欠品区分別(2.メーカー責)", K22KR: "欠品区分別(2.メーカー責)", 
    K29KQ: "欠品区分別(2.メーカー責)", K29KA: "欠品区分別(2.メーカー責)", K29KR: "欠品区分別(2.メーカー責)", 
    K30KQ: "欠品区分別(3.得意先責)", K30KA: "欠品区分別(3.得意先責)", K30KR: "欠品区分別(3.得意先責)", 
    K31KQ: "欠品区分別(3.得意先責)", K31KA: "欠品区分別(3.得意先責)", K31KR: "欠品区分別(3.得意先責)", 
    K32KQ: "欠品区分別(3.得意先責)", K32KA: "欠品区分別(3.得意先責)", K32KR: "欠品区分別(3.得意先責)", 
    K33KQ: "欠品区分別(3.得意先責)", K33KA: "欠品区分別(3.得意先責)", K33KR: "欠品区分別(3.得意先責)", 
    K41KQ: "欠品区分別(3.得意先責)", K41KA: "欠品区分別(3.得意先責)", K41KR: "欠品区分別(3.得意先責)", 
    K34KQ: "欠品区分別(3.得意先責)", K34KA: "欠品区分別(3.得意先責)", K34KR: "欠品区分別(3.得意先責)", 
    K39KQ: "欠品区分別(3.得意先責)", K39KA: "欠品区分別(3.得意先責)", K39KR: "欠品区分別(3.得意先責)", 
    K40KQ: "欠品区分別(3.得意先責)", K40KA: "欠品区分別(3.得意先責)", K40KR: "欠品区分別(3.得意先責)", 
    K42KQ: "欠品区分別(3.得意先責)", K42KA: "欠品区分別(3.得意先責)", K42KR: "欠品区分別(3.得意先責)", 
    K43KQ: "欠品区分別(3.得意先責)", K43KA: "欠品区分別(3.得意先責)", K43KR: "欠品区分別(3.得意先責)", 
    K44KQ: "欠品区分別(3.得意先責)", K44KA: "欠品区分別(3.得意先責)", K44KR: "欠品区分別(3.得意先責)", 
    K49KQ: "欠品区分別(3.得意先責)", K49KA: "欠品区分別(3.得意先責)", K49KR: "欠品区分別(3.得意先責)", 
    K50KQ: "欠品区分別(3.得意先責)", K50KA: "欠品区分別(3.得意先責)", K50KR: "欠品区分別(3.得意先責)", 
  
  
    LQT: "販売数量", LQP: "販売数量", LQR: "販売数量", LQD: "販売数量", DQT: "販売数量", DQP: "販売数量", DQR: "販売数量", DQD: "販売数量", OQT: "販売数量", OQP: "販売数量", OQR: "販売数量", OQD: "販売数量", ULT: "販売数量", ULP: "販売数量", ULR: "販売数量", ULD: "販売数量", UDT: "販売数量", UDP: "販売数量", UDR: "販売数量", UDD: "販売数量", UPT: "販売数量", UPP: "販売数量", UPR: "販売数量", UPD: "販売数量", SQT: "販売数量", SQP: "販売数量", SQR: "販売数量", SQD: "販売数量",RQT: "販売数量", RQP: "販売数量", RQR: "販売数量", RQD: "販売数量", WQT: "販売数量", WQP: "販売数量", WQR: "販売数量", WQD: "販売数量",
    SLT: "総売上", SLP: "総売上", SLR: "総売上", SLD: "総売上", SDT: "総売上", SDP: "総売上", SDR: "総売上", SDD: "総売上", SRT: "総売上", SRP: "総売上", SRR: "総売上", SRD: "総売上", STT: "総売上", STP: "総売上", STR: "総売上", STD: "総売上",
    PTT: "売買差益", PTP: "売買差益", PTD: "売買差益", PRT: "売買差益", PRP: "売買差益", PRD: "売買差益",
    CIT: "修正", CIP: "修正", CIR: "修正", CID: "修正", CST: "修正", CSP: "修正", CSR: "修正", CSD: "修正", CTT: "修正", CTP: "修正", CTR: "修正", CTD: "修正",
    BTT: "総利益", BTP: "総利益", BTR: "総利益", BTD: "総利益", BRT: "総利益", BRP: "総利益", BRD: "総利益", ATT: "総利益", ATP: "総利益", ATR: "総利益", ATD: "総利益", ART: "総利益", ARP: "総利益", ARD: "総利益",
    SHCT: "仕入実績", SHCP: "仕入実績", SHCR: "仕入実績", SHCD2: "仕入実績", 
    SHDT: "仕入実績", SHDP: "仕入実績", SHDR: "仕入実績", SHDD: "仕入実績", 
    SHRCT: "仕入実績", SHRCP: "仕入実績", SHRCR: "仕入実績", SHRCD: "仕入実績", 
    SHRDT: "仕入実績", SHRDP: "仕入実績", SHRDR: "仕入実績", SHRDD: "仕入実績", 
    SHT: "仕入実績", SHP: "仕入実績", SHR: "仕入実績", SHD: "仕入実績", 
  },
  {
    JJT: "受注額", JJTK: "受注額", JJP: "受注額", JJPK: "受注額", JJR: "受注額", JJD: "受注額", 
    JJQT: "受注BL数", JJTQK: "受注BL数", JJQP: "受注BL数", JJPQK: "受注BL数", JJQR: "受注BL数", JJQD: "受注BL数", 
    JKT: "欠品額", JKTK: "欠品額", JKP: "欠品額", JKPK: "欠品額", JKR: "欠品額", JKD: "欠品額", 
    JKQT: "欠品BL数", JKTQK: "欠品BL数", JKQP: "欠品BL数", JKPQK: "欠品BL数", JKQR: "欠品BL数", JKQD: "欠品BL数", 
    JRT: "欠品率", JRP: "欠品率", JRD: "欠品率", 
    //欠品責任別
    KI1KQ: '1.自社責', KI1KA: '1.自社責', KI1KR: '1.自社責', 
    KI2KQ: '2.メーカー責', KI2KA: '2.メーカー責', KI2KR: '2.メーカー責', 
    KI3KQ: '3.得意先責', KI3KA: '3.得意先責', KI3KR: '3.得意先責', 
  
    //欠品区分別
    K10KQ: '10.未入力', K10KA: '10.未入力', K10KR: '10.未入力', 
    K11KQ: '11.発注漏れ', K11KA: '11.発注漏れ', K11KR: '11.発注漏れ', 
    K12KQ: '12.終売案内漏れ', K12KA: '12.終売案内漏れ', K12KR: '12.終売案内漏れ', 
    K13KQ: '13.※※使用不可※※', K13KA: '13.※※使用不可※※', K13KR: '13.※※使用不可※※', 
    K14KQ: '14.発注数量予測差異', K14KA: '14.発注数量予測差異', K14KR: '14.発注数量予測差異', 
    K15KQ: '15.自社出荷ミス', K15KA: '15.自社出荷ミス', K15KR: '15.自社出荷ミス', 
    K16KQ: '16.出荷許容切れ', K16KA: '16.出荷許容切れ', K16KR: '16.出荷許容切れ', 
    K17KQ: '17.特売連絡漏', K17KA: '17.特売連絡漏', K17KR: '17.特売連絡漏', 
    K19KQ: '19.自社その他', K19KA: '19.自社その他', K19KR: '19.自社その他', 
    K20KQ: '20.メーカー欠品', K20KA: '20.メーカー欠品', K20KR: '20.メーカー欠品', 
    K21KQ: '21.配送', K21KA: '21.配送', K21KR: '21.配送', 
    K22KQ: '22.天災', K22KA: '22.天災', K22KR: '22.天災', 
    K29KQ: '29.メーカー欠品その他', K29KA: '29.メーカー欠品その他', K29KR: '29.メーカー欠品その他', 
    K30KQ: '30.数量訂正・発注取消', K30KA: '30.数量訂正・発注取消', K30KR: '30.数量訂正・発注取消', 
    K31KQ: '31.得意先フライング', K31KA: '31.得意先フライング', K31KR: '31.得意先フライング', 
    K32KQ: '32.※※使用不可※※', K32KA: '32.※※使用不可※※', K32KR: '32.※※使用不可※※', 
    K33KQ: '33.※※使用不可※※', K33KA: '33.※※使用不可※※', K33KR: '33.※※使用不可※※', 
    K41KQ: '41.納品日エラー', K41KA: '41.納品日エラー', K41KR: '41.納品日エラー', 
    K34KQ: '34.得意先定番外・カット', K34KA: '34.得意先定番外・カット', K34KR: '34.得意先定番外・カット', 
    K39KQ: '39.※※使用不可※※', K39KA: '39.※※使用不可※※', K39KR: '39.※※使用不可※※', 
    K40KQ: '40.得意先商品CDエラー', K40KA: '40.得意先商品CDエラー', K40KR: '40.得意先商品CDエラー', 
    K42KQ: '42.得意先入数エラー', K42KA: '42.得意先入数エラー', K42KR: '42.得意先入数エラー', 
    K43KQ: '43.単価エラー', K43KA: '43.単価エラー', K43KR: '43.単価エラー', 
    K44KQ: '44.※※使用不可※※', K44KA: '44.※※使用不可※※', K44KR: '44.※※使用不可※※', 
    K49KQ: '49.※※使用不可※※', K49KA: '49.※※使用不可※※', K49KR: '49.※※使用不可※※', 
    K50KQ: '50.得意先検品ミス', K50KA: '50.得意先検品ミス', K50KR: '50.得意先検品ミス', 
  
    LQT: "配送出荷BL数", LQP: "配送出荷BL数", LQR: "配送出荷BL数", LQD: "配送出荷BL数", DQT: "直送出荷BL数", DQP: "直送出荷BL数", DQR: "直送出荷BL数", DQD: "直送出荷BL数", OQT: "出荷BL数", OQP: "出荷BL数", OQR: "出荷BL数", OQD: "出荷BL数", ULT: "配送未計上売上BL数", ULP: "配送未計上売上BL数", ULR: "配送未計上売上BL数", ULD: "配送未計上売上BL数", UDT: "直送未計上売上BL数", UDP: "直送未計上売上BL数", UDR: "直送未計上売上BL数", UDD: "直送未計上売上BL数", UPT: "未計上売上BL数", UPP: "未計上売上BL数", UPR: "未計上売上BL数", UPD: "未計上売上BL数", SQT: "販売BL数", SQP: "販売BL数", SQR: "販売BL数", SQD: "販売BL数", RQT: "返品BL数", RQP: "返品BL数", RQR: "返品BL数", RQD: "返品BL数", WQT: "廃棄BL数", WQP: "廃棄BL数", WQR: "廃棄BL数", WQD: "廃棄BL数",
    SLT: "配送売上", SLP: "配送売上", SLR: "配送売上", SLD: "配送売上", SDT: "直送売上", SDP: "直送売上", SDR: "直送売上", SDD: "直送売上", SRT: "返品", SRP: "返品", SRR: "返品", SRD: "返品", STT: "総売上", STP: "総売上", STR: "総売上", STD: "総売上",
    PTT: "売買差益計", PTP: "売買差益計", PTD: "売買差益計", PRT: "売買差益率", PRP: "売買差益率", PRD: "売買差益率",
    CIT: "入力修正", CIP: "入力修正", CIR: "入力修正", CID: "入力修正", CST: "黒修正", CSP: "黒修正", CSR: "黒修正", CSD: "黒修正", CTT: "修正合計", CTP: "修正合計", CTR: "修正合計", CTD: "修正合計",
    BTT: "修正前企業粗利", BTP: "修正前企業粗利", BTR: "修正前企業粗利", BTD: "修正前企業粗利", BRT: "修正前企業粗利率", BRP: "修正前企業粗利率", BRD: "修正前企業粗利率", ATT: "修正後企業粗利", ATP: "修正後企業粗利", ATR: "修正後企業粗利", ATD: "修正後企業粗利", ART: "修正後企業粗利率", ARP: "修正後企業粗利率", ARD: "修正後企業粗利率",
    SHCT: "仕入（倉入）", SHCP: "仕入（倉入）", SHCR: "仕入（倉入）", SHCD2: "仕入（倉入）", 
    SHDT: "仕入（直送）", SHDP: "仕入（直送）", SHDR: "仕入（直送）", SHDD: "仕入（直送）", 
    SHRCT: "仕入返品（倉入）", SHRCP: "仕入返品（倉入）", SHRCR: "仕入返品（倉入）", SHRCD: "仕入返品（倉入）", 
    SHRDT: "仕入返品（直送）", SHRDP: "仕入返品（直送）", SHRDR: "仕入返品（直送）", SHRDD: "仕入返品（直送）", 
    SHT: "仕入合計", SHP: "仕入合計", SHR: "仕入合計", SHD: "仕入合計",
  },
  {
    JJT: "本年実績", JJP: "前年実績", JJR: "前年比", JJD: "前年差", 
    JJQT: "本年実績", JJQP: "前年実績", JJQR: "前年比", JJQD: "前年差", 
    JKT: "本年実績", JKP: "前年実績", JKR: "前年比", JKD: "前年差", 
    JKQT: "本年実績", JKQP: "前年実績", JKQR: "前年比", JKQD: "前年差", 
    JRT: "本年実績", JRP: "前年実績", JRD: "前年差", 

    //欠品責任別
    KI1KQ: '欠品BL数', KI1KA: '欠品額', KI1KR: '欠品率', 
    KI2KQ: '欠品BL数', KI2KA: '欠品額', KI2KR: '欠品率', 
    KI3KQ: '欠品BL数', KI3KA: '欠品額', KI3KR: '欠品率', 
  
    //欠品区分別
    K10KQ: '欠品BL数', K10KA: '欠品額', K10KR: '欠品率', 
    K11KQ: '欠品BL数', K11KA: '欠品額', K11KR: '欠品率', 
    K12KQ: '欠品BL数', K12KA: '欠品額', K12KR: '欠品率', 
    K13KQ: '欠品BL数', K13KA: '欠品額', K13KR: '欠品率', 
    K14KQ: '欠品BL数', K14KA: '欠品額', K14KR: '欠品率', 
    K15KQ: '欠品BL数', K15KA: '欠品額', K15KR: '欠品率', 
    K16KQ: '欠品BL数', K16KA: '欠品額', K16KR: '欠品率', 
    K17KQ: '欠品BL数', K17KA: '欠品額', K17KR: '欠品率', 
    K19KQ: '欠品BL数', K19KA: '欠品額', K19KR: '欠品率', 
    K20KQ: '欠品BL数', K20KA: '欠品額', K20KR: '欠品率', 
    K21KQ: '欠品BL数', K21KA: '欠品額', K21KR: '欠品率', 
    K22KQ: '欠品BL数', K22KA: '欠品額', K22KR: '欠品率', 
    K29KQ: '欠品BL数', K29KA: '欠品額', K29KR: '欠品率', 
    K30KQ: '欠品BL数', K30KA: '欠品額', K30KR: '欠品率', 
    K31KQ: '欠品BL数', K31KA: '欠品額', K31KR: '欠品率', 
    K32KQ: '欠品BL数', K32KA: '欠品額', K32KR: '欠品率', 
    K33KQ: '欠品BL数', K33KA: '欠品額', K33KR: '欠品率', 
    K41KQ: '欠品BL数', K41KA: '欠品額', K41KR: '欠品率', 
    K34KQ: '欠品BL数', K34KA: '欠品額', K34KR: '欠品率', 
    K39KQ: '欠品BL数', K39KA: '欠品額', K39KR: '欠品率', 
    K40KQ: '欠品BL数', K40KA: '欠品額', K40KR: '欠品率', 
    K42KQ: '欠品BL数', K42KA: '欠品額', K42KR: '欠品率', 
    K43KQ: '欠品BL数', K43KA: '欠品額', K43KR: '欠品率', 
    K44KQ: '欠品BL数', K44KA: '欠品額', K44KR: '欠品率', 
    K49KQ: '欠品BL数', K49KA: '欠品額', K49KR: '欠品率', 
    K50KQ: '欠品BL数', K50KA: '欠品額', K50KR: '欠品率', 
  
    LQT: "本年実績", LQP: "前年実績", LQR: "前年比", LQD: "前年差", DQT: "本年実績", DQP: "前年実績", DQR: "前年比", DQD: "前年差", OQT: "本年実績", OQP: "前年実績", OQR: "前年比", OQD: "前年差", ULT: "本年実績", ULP: "前年実績", ULR: "前年比", ULD: "前年差", UDT: "本年実績", UDP: "前年実績", UDR: "前年比", UDD: "前年差", UPT: "本年実績", UPP: "前年実績", UPR: "前年比", UPD: "前年差", SQT: "本年実績", SQP: "前年実績", SQR: "前年比", SQD: "前年差", RQT: "本年実績", RQP: "前年実績", RQR: "前年比", RQD: "前年差", WQT: "本年実績", WQP: "前年実績", WQR: "前年比", WQD: "前年差",
    SLT: "本年実績", SLP: "前年実績", SLR: "前年比", SLD: "前年差", SDT: "本年実績", SDP: "前年実績", SDR: "前年比", SDD: "前年差", SRT: "本年実績", SRP: "前年実績", SRR: "前年比", SRD: "前年差", STT: "本年実績", STP: "前年実績", STR: "前年比", STD: "前年差",
    PTT: "本年実績", PTP: "前年実績", PTD: "前年差", PRT: "本年実績", PRP: "前年実績", PRD: "前年差",
    CIT: "本年実績", CIP: "前年実績", CIR: "前年比", CID: "前年差", CST: "本年実績", CSP: "前年実績", CSR: "前年比", CSD: "前年差", CTT: "本年実績", CTP: "前年実績", CTR: "前年比", CTD: "前年差",
    BTT: "本年実績", BTP: "前年実績", BTR: "前年比", BTD: "前年差", BRT: "本年実績", BRP: "前年実績", BRD: "前年差", ATT: "本年実績", ATP: "前年実績", ATR: "前年比", ATD: "前年差", ART: "本年実績", ARP: "前年実績", ARD: "前年差",
    SHCT: "本年実績", SHCP: "前年実績", SHCR: "前年比", SHCD2: "前年差",
    SHDT: "本年実績", SHDP: "前年実績", SHDR: "前年比", SHDD: "前年差",
    SHRCT: "本年実績", SHRCP: "前年実績", SHRCR: "前年比", SHRCD: "前年差",
    SHRDT: "本年実績", SHRDP: "前年実績", SHRDR: "前年比", SHRDD: "前年差",
    SHT: "本年実績", SHP: "前年実績", SHR: "前年比", SHD: "前年差",
  },
];
export const headersRowDaily = [
  {

    JJT: "受注", JJTK: "受注", JJP: "受注", JJPK: "受注", JJR: "受注", JJD: "受注", 
    JJQT: "受注", JJTQK: "受注", JJQP: "受注", JJPQK: "受注", JJQR: "受注", JJQD: "受注", 
    JST: "配送売上", JSTK: "配送売上", JSP: "配送売上", JSPK: "配送売上", JSR: "配送売上", JSD: "配送売上", 
    JSQT: "配送売上", JSTQK: "配送売上", JSQP: "配送売上", JSPQK: "配送売上", JSQR: "配送売上", JSQD: "配送売上", 
    JKT: "欠品", JKTK: "欠品", JKP: "欠品", JKPK: "欠品", JKR: "欠品", JKD: "欠品", 
    JKQT: "欠品", JKTQK: "欠品", JKQP: "欠品", JKPQK: "欠品", JKQR: "欠品", JKQD: "欠品", 
    JRT: "欠品", JRP: "欠品", JRD: "欠品", 
    //欠品責任別
    KI1KQ: "欠品責任別", KI1KA: "欠品責任別", KI1KR: "欠品責任別", 
    KI2KQ: "欠品責任別", KI2KA: "欠品責任別", KI2KR: "欠品責任別", 
    KI3KQ: "欠品責任別", KI3KA: "欠品責任別", KI3KR: "欠品責任別", 
    //欠品区分別
    K10KQ: "欠品区分別(1.自社責)", K10KA: "欠品区分別(1.自社責)", K10KR: "欠品区分別(1.自社責)", 
    K11KQ: "欠品区分別(1.自社責)", K11KA: "欠品区分別(1.自社責)", K11KR: "欠品区分別(1.自社責)", 
    K12KQ: "欠品区分別(1.自社責)", K12KA: "欠品区分別(1.自社責)", K12KR: "欠品区分別(1.自社責)", 
    K13KQ: "欠品区分別(1.自社責)", K13KA: "欠品区分別(1.自社責)", K13KR: "欠品区分別(1.自社責)", 
    K14KQ: "欠品区分別(1.自社責)", K14KA: "欠品区分別(1.自社責)", K14KR: "欠品区分別(1.自社責)", 
    K15KQ: "欠品区分別(1.自社責)", K15KA: "欠品区分別(1.自社責)", K15KR: "欠品区分別(1.自社責)", 
    K16KQ: "欠品区分別(1.自社責)", K16KA: "欠品区分別(1.自社責)", K16KR: "欠品区分別(1.自社責)", 
    K17KQ: "欠品区分別(1.自社責)", K17KA: "欠品区分別(1.自社責)", K17KR: "欠品区分別(1.自社責)", 
    K19KQ: "欠品区分別(1.自社責)", K19KA: "欠品区分別(1.自社責)", K19KR: "欠品区分別(1.自社責)", 
    K20KQ: "欠品区分別(2.メーカー責)", K20KA: "欠品区分別(2.メーカー責)", K20KR: "欠品区分別(2.メーカー責)", 
    K21KQ: "欠品区分別(2.メーカー責)", K21KA: "欠品区分別(2.メーカー責)", K21KR: "欠品区分別(2.メーカー責)", 
    K22KQ: "欠品区分別(2.メーカー責)", K22KA: "欠品区分別(2.メーカー責)", K22KR: "欠品区分別(2.メーカー責)", 
    K29KQ: "欠品区分別(2.メーカー責)", K29KA: "欠品区分別(2.メーカー責)", K29KR: "欠品区分別(2.メーカー責)", 
    K30KQ: "欠品区分別(3.得意先責)", K30KA: "欠品区分別(3.得意先責)", K30KR: "欠品区分別(3.得意先責)", 
    K31KQ: "欠品区分別(3.得意先責)", K31KA: "欠品区分別(3.得意先責)", K31KR: "欠品区分別(3.得意先責)", 
    K32KQ: "欠品区分別(3.得意先責)", K32KA: "欠品区分別(3.得意先責)", K32KR: "欠品区分別(3.得意先責)", 
    K33KQ: "欠品区分別(3.得意先責)", K33KA: "欠品区分別(3.得意先責)", K33KR: "欠品区分別(3.得意先責)", 
    K41KQ: "欠品区分別(3.得意先責)", K41KA: "欠品区分別(3.得意先責)", K41KR: "欠品区分別(3.得意先責)", 
    K34KQ: "欠品区分別(3.得意先責)", K34KA: "欠品区分別(3.得意先責)", K34KR: "欠品区分別(3.得意先責)", 
    K39KQ: "欠品区分別(3.得意先責)", K39KA: "欠品区分別(3.得意先責)", K39KR: "欠品区分別(3.得意先責)", 
    K40KQ: "欠品区分別(3.得意先責)", K40KA: "欠品区分別(3.得意先責)", K40KR: "欠品区分別(3.得意先責)", 
    K42KQ: "欠品区分別(3.得意先責)", K42KA: "欠品区分別(3.得意先責)", K42KR: "欠品区分別(3.得意先責)", 
    K43KQ: "欠品区分別(3.得意先責)", K43KA: "欠品区分別(3.得意先責)", K43KR: "欠品区分別(3.得意先責)", 
    K44KQ: "欠品区分別(3.得意先責)", K44KA: "欠品区分別(3.得意先責)", K44KR: "欠品区分別(3.得意先責)", 
    K49KQ: "欠品区分別(3.得意先責)", K49KA: "欠品区分別(3.得意先責)", K49KR: "欠品区分別(3.得意先責)", 
    K50KQ: "欠品区分別(3.得意先責)", K50KA: "欠品区分別(3.得意先責)", K50KR: "欠品区分別(3.得意先責)", 
  },
  {
    JJT: "受注額", JJTK: "受注額", JJP: "受注額", JJPK: "受注額", JJR: "受注額", JJD: "受注額", 
    JJQT: "受注BL数", JJTQK: "受注BL数", JJQP: "受注BL数", JJPQK: "受注BL数", JJQR: "受注BL数", JJQD: "受注BL数", 
    JST: "売上額", JSTK: "売上額", JSP: "売上額", JSPK: "売上額", JSR: "売上額", JSD: "売上額", 
    JSQT: "売上BL数", JSTQK: "売上BL数", JSQP: "売上BL数", JSPQK: "売上BL数", JSQR: "売上BL数", JSQD: "売上BL数", 
    JKT: "欠品額", JKTK: "欠品額", JKP: "欠品額", JKPK: "欠品額", JKR: "欠品額", JKD: "欠品額", 
    JKQT: "欠品BL数", JKTQK: "欠品BL数", JKQP: "欠品BL数", JKPQK: "欠品BL数", JKQR: "欠品BL数", JKQD: "欠品BL数", 
    JRT: "欠品率", JRP: "欠品率", JRD: "欠品率", 
    //欠品責任別
    KI1KQ: '1.自社責', KI1KA: '1.自社責', KI1KR: '1.自社責', 
    KI2KQ: '2.メーカー責', KI2KA: '2.メーカー責', KI2KR: '2.メーカー責', 
    KI3KQ: '3.得意先責', KI3KA: '3.得意先責', KI3KR: '3.得意先責', 
  
    //欠品区分別
    K10KQ: '10.未入力', K10KA: '10.未入力', K10KR: '10.未入力', 
    K11KQ: '11.発注漏れ', K11KA: '11.発注漏れ', K11KR: '11.発注漏れ', 
    K12KQ: '12.終売案内漏れ', K12KA: '12.終売案内漏れ', K12KR: '12.終売案内漏れ', 
    K13KQ: '13.※※使用不可※※', K13KA: '13.※※使用不可※※', K13KR: '13.※※使用不可※※', 
    K14KQ: '14.発注数量予測差異', K14KA: '14.発注数量予測差異', K14KR: '14.発注数量予測差異', 
    K15KQ: '15.自社出荷ミス', K15KA: '15.自社出荷ミス', K15KR: '15.自社出荷ミス', 
    K16KQ: '16.出荷許容切れ', K16KA: '16.出荷許容切れ', K16KR: '16.出荷許容切れ', 
    K17KQ: '17.特売連絡漏', K17KA: '17.特売連絡漏', K17KR: '17.特売連絡漏', 
    K19KQ: '19.自社その他', K19KA: '19.自社その他', K19KR: '19.自社その他', 
    K20KQ: '20.メーカー欠品', K20KA: '20.メーカー欠品', K20KR: '20.メーカー欠品', 
    K21KQ: '21.配送', K21KA: '21.配送', K21KR: '21.配送', 
    K22KQ: '22.天災', K22KA: '22.天災', K22KR: '22.天災', 
    K29KQ: '29.メーカー欠品その他', K29KA: '29.メーカー欠品その他', K29KR: '29.メーカー欠品その他', 
    K30KQ: '30.数量訂正・発注取消', K30KA: '30.数量訂正・発注取消', K30KR: '30.数量訂正・発注取消', 
    K31KQ: '31.得意先フライング', K31KA: '31.得意先フライング', K31KR: '31.得意先フライング', 
    K32KQ: '32.※※使用不可※※', K32KA: '32.※※使用不可※※', K32KR: '32.※※使用不可※※', 
    K33KQ: '33.※※使用不可※※', K33KA: '33.※※使用不可※※', K33KR: '33.※※使用不可※※', 
    K41KQ: '41.納品日エラー', K41KA: '41.納品日エラー', K41KR: '41.納品日エラー', 
    K34KQ: '34.得意先定番外・カット', K34KA: '34.得意先定番外・カット', K34KR: '34.得意先定番外・カット', 
    K39KQ: '39.※※使用不可※※', K39KA: '39.※※使用不可※※', K39KR: '39.※※使用不可※※', 
    K40KQ: '40.得意先商品CDエラー', K40KA: '40.得意先商品CDエラー', K40KR: '40.得意先商品CDエラー', 
    K42KQ: '42.得意先入数エラー', K42KA: '42.得意先入数エラー', K42KR: '42.得意先入数エラー', 
    K43KQ: '43.単価エラー', K43KA: '43.単価エラー', K43KR: '43.単価エラー', 
    K44KQ: '44.※※使用不可※※', K44KA: '44.※※使用不可※※', K44KR: '44.※※使用不可※※', 
    K49KQ: '49.※※使用不可※※', K49KA: '49.※※使用不可※※', K49KR: '49.※※使用不可※※', 
    K50KQ: '50.得意先検品ミス', K50KA: '50.得意先検品ミス', K50KR: '50.得意先検品ミス', 
  },
  {
    JJT: "本年実績", JJP: "前年実績", JJR: "前年比", JJD: "前年差", 
    JJQT: "本年実績", JJQP: "前年実績", JJQR: "前年比", JJQD: "前年差", 
    JST: "本年実績", JSP: "前年実績", JSR: "前年比", JSD: "前年差", 
    JSQT: "本年実績", JSQP: "前年実績", JSQR: "前年比", JSQD: "前年差", 
    JKT: "本年実績", JKP: "前年実績", JKR: "前年比", JKD: "前年差", 
    JKQT: "本年実績", JKQP: "前年実績", JKQR: "前年比", JKQD: "前年差", 
    JRT: "本年実績", JRP: "前年実績", JRD: "前年差", 
    //欠品責任別
    KI1KQ: '欠品BL数', KI1KA: '欠品額', KI1KR: '欠品率', 
    KI2KQ: '欠品BL数', KI2KA: '欠品額', KI2KR: '欠品率', 
    KI3KQ: '欠品BL数', KI3KA: '欠品額', KI3KR: '欠品率', 
  
    //欠品区分別
    K10KQ: '欠品BL数', K10KA: '欠品額', K10KR: '欠品率', 
    K11KQ: '欠品BL数', K11KA: '欠品額', K11KR: '欠品率', 
    K12KQ: '欠品BL数', K12KA: '欠品額', K12KR: '欠品率', 
    K13KQ: '欠品BL数', K13KA: '欠品額', K13KR: '欠品率', 
    K14KQ: '欠品BL数', K14KA: '欠品額', K14KR: '欠品率', 
    K15KQ: '欠品BL数', K15KA: '欠品額', K15KR: '欠品率', 
    K16KQ: '欠品BL数', K16KA: '欠品額', K16KR: '欠品率', 
    K17KQ: '欠品BL数', K17KA: '欠品額', K17KR: '欠品率', 
    K19KQ: '欠品BL数', K19KA: '欠品額', K19KR: '欠品率', 
    K20KQ: '欠品BL数', K20KA: '欠品額', K20KR: '欠品率', 
    K21KQ: '欠品BL数', K21KA: '欠品額', K21KR: '欠品率', 
    K22KQ: '欠品BL数', K22KA: '欠品額', K22KR: '欠品率', 
    K29KQ: '欠品BL数', K29KA: '欠品額', K29KR: '欠品率', 
    K30KQ: '欠品BL数', K30KA: '欠品額', K30KR: '欠品率', 
    K31KQ: '欠品BL数', K31KA: '欠品額', K31KR: '欠品率', 
    K32KQ: '欠品BL数', K32KA: '欠品額', K32KR: '欠品率', 
    K33KQ: '欠品BL数', K33KA: '欠品額', K33KR: '欠品率', 
    K41KQ: '欠品BL数', K41KA: '欠品額', K41KR: '欠品率', 
    K34KQ: '欠品BL数', K34KA: '欠品額', K34KR: '欠品率', 
    K39KQ: '欠品BL数', K39KA: '欠品額', K39KR: '欠品率', 
    K40KQ: '欠品BL数', K40KA: '欠品額', K40KR: '欠品率', 
    K42KQ: '欠品BL数', K42KA: '欠品額', K42KR: '欠品率', 
    K43KQ: '欠品BL数', K43KA: '欠品額', K43KR: '欠品率', 
    K44KQ: '欠品BL数', K44KA: '欠品額', K44KR: '欠品率', 
    K49KQ: '欠品BL数', K49KA: '欠品額', K49KR: '欠品率', 
    K50KQ: '欠品BL数', K50KA: '欠品額', K50KR: '欠品率', 
  
  },
];

export const selectableCol =
{
  no : false,
  rowHeader1 : false, rowHeader2 : false, rowHeader3 : false,
  //以下に貼り付け
  ISC: true, ISN: true, IMC: true, IMN: true, INM: true, ICC: true, ICN: true, IBC: true, IBN: true, IJN: true, ICD: true, ICP: true, IC1: true, IC2: true, ILI: true, IPR: true,
  TTL: false,
  T01: false, T02: false, T03: false, T04: false, T05: false, T06: false, T07: false, T08: false, T09: false, T10: false,
  T11: false, T12: false, T13: false, T14: false, T15: false, T16: false, T17: false, T18: false, T19: false, T20: false,
  T21: false, T22: false, T23: false, T24: false, T25: false, T26: false, T27: false, T28: false, T29: false, T30: false,
  T31: false,
}
export const selectableRow =
{
  JJT: true, JJP: true, JJR: true, JJD: true, 
  JJQT: true, JJQP: true, JJQR: true, JJQD: true, 
  JST: true, JSP: true, JSR: true, JSD: true, 
  JSQT: true, JSQP: true, JSQR: true, JSQD: true, 
  JKT: true, JKP: true, JKR: true, JKD: true, 
  JKQT: true, JKQP: true, JKQR: true, JKQD: true, 
  JRT: true, JRP: true, JRD: true, 
  //欠品責任別
  KI1KQ: true, KI1KA: true, KI1KR: true, 
  KI2KQ: true, KI2KA: true, KI2KR: true, 
  KI3KQ: true, KI3KA: true, KI3KR: true, 
  //欠品区分別
  K10KQ: true, K10KA: true, K10KR: true, 
  K11KQ: true, K11KA: true, K11KR: true, 
  K12KQ: true, K12KA: true, K12KR: true, 
  K13KQ: true, K13KA: true, K13KR: true, 
  K14KQ: true, K14KA: true, K14KR: true, 
  K15KQ: true, K15KA: true, K15KR: true, 
  K16KQ: true, K16KA: true, K16KR: true, 
  K17KQ: true, K17KA: true, K17KR: true, 
  K19KQ: true, K19KA: true, K19KR: true, 
  K20KQ: true, K20KA: true, K20KR: true, 
  K21KQ: true, K21KA: true, K21KR: true, 
  K22KQ: true, K22KA: true, K22KR: true, 
  K29KQ: true, K29KA: true, K29KR: true, 
  K30KQ: true, K30KA: true, K30KR: true, 
  K31KQ: true, K31KA: true, K31KR: true, 
  K32KQ: true, K32KA: true, K32KR: true, 
  K33KQ: true, K33KA: true, K33KR: true, 
  K41KQ: true, K41KA: true, K41KR: true, 
  K34KQ: true, K34KA: true, K34KR: true, 
  K39KQ: true, K39KA: true, K39KR: true, 
  K40KQ: true, K40KA: true, K40KR: true, 
  K42KQ: true, K42KA: true, K42KR: true, 
  K43KQ: true, K43KA: true, K43KR: true, 
  K44KQ: true, K44KA: true, K44KR: true, 
  K49KQ: true, K49KA: true, K49KR: true, 
  K50KQ: true, K50KA: true, K50KR: true, 

  LQT: true, LQP: true, LQR: true, LQD: true, DQT: true, DQP: true, DQR: true, DQD: true, OQT: true, OQP: true, OQR: true, OQD: true, ULT: true, ULP: true, ULR: true, ULD: true, UDT: true, UDP: true, UDR: true, UDD: true, UPT: true, UPP: true, UPR: true, UPD: true, SQT: true, SQP: true, SQR: true, SQD: true, RQT: true, RQP: true, RQR: true, RQD: true, WQT: true, WQP: true, WQR: true, WQD: true,
  SLT: true, SLP: true, SLR: true, SLD: true, SDT: true, SDP: true, SDR: true, SDD: true, SRT: true, SRP: true, SRR: true, SRD: true, STT: true, STP: true, STR: true, STD: true,
  PTT: true, PTP: true, PTD: true, PRT: true, PRP: true, PRD: true,
  CIT: true, CIP: true, CIR: true, CID: true, CST: true, CSP: true, CSR: true, CSD: true, CTT: true, CTP: true, CTR: true, CTD: true,
  BTT: true, BTP: true, BTR: true, BTD: true, BRT: true, BRP: true, BRD: true, ATT: true, ATP: true, ATR: true, ATD: true, ART: true, ARP: true, ARD: true,
  SHCT: true, SHCP: true, SHCR: true, SHCD2: true, 
  SHDT: true, SHDP: true, SHDR: true, SHDD: true, 
  SHRCT: true, SHRCP: true, SHRCR: true, SHRCD: true, 
  SHRDT: true, SHRDP: true, SHRDR: true, SHRDD: true, 
  SHT: true, SHP: true, SHR: true, SHD: true,
}

export const headerColClasses = [
  {
    no : "itemlisttrans_H",
    rowHeader1 : "itemlisttrans_H", rowHeader2 : "itemlisttrans_H", rowHeader3 : "itemlisttrans_H",
    //以下に貼り付け
    H1CD: "itemlisttrans_H", H1NM: "itemlisttrans_H", H2CD: "itemlisttrans_H", H2NM: "itemlisttrans_H", H3CD: "itemlisttrans_H", H3NM: "itemlisttrans_H", H4CD: "itemlisttrans_H", H4NM: "itemlisttrans_H", H5CD: "itemlisttrans_H", H5NM: "itemlisttrans_H", H6CD: "itemlisttrans_H", H6NM: "itemlisttrans_H", H7CD: "itemlisttrans_H", H7NM: "itemlisttrans_H", H8CD: "itemlisttrans_H", H8NM: "itemlisttrans_H",
    ISC: "itemlisttrans_I", ISN: "itemlisttrans_I", IMC: "itemlisttrans_I", IMN: "itemlisttrans_I", INM: "itemlisttrans_I", ICC: "itemlisttrans_I", ICN: "itemlisttrans_I", IBC: "itemlisttrans_I", IBN: "itemlisttrans_I", IJN: "itemlisttrans_I", ICD: "itemlisttrans_I", ICP: "itemlisttrans_I", IC1: "itemlisttrans_I", IC2: "itemlisttrans_I", ILI: "itemlisttrans_I", IPR: "itemlisttrans_I",
    TTL: "itemlisttrans_H",
    T01: "itemlisttrans_H", T02: "itemlisttrans_H", T03: "itemlisttrans_H", T04: "itemlisttrans_H", T05: "itemlisttrans_H", T06: "itemlisttrans_H", T07: "itemlisttrans_H", T08: "itemlisttrans_H", T09: "itemlisttrans_H", T10: "itemlisttrans_H",
    T11: "itemlisttrans_H", T12: "itemlisttrans_H", T13: "itemlisttrans_H", T14: "itemlisttrans_H", T15: "itemlisttrans_H", T16: "itemlisttrans_H", T17: "itemlisttrans_H", T18: "itemlisttrans_H", T19: "itemlisttrans_H", T20: "itemlisttrans_H",
    T21: "itemlisttrans_H", T22: "itemlisttrans_H", T23: "itemlisttrans_H", T24: "itemlisttrans_H", T25: "itemlisttrans_H", T26: "itemlisttrans_H", T27: "itemlisttrans_H", T28: "itemlisttrans_H", T29: "itemlisttrans_H", T30: "itemlisttrans_H",
    T31: "itemlisttrans_H",
  },
  {
    no : "itemlisttrans_H",
    rowHeader1 : "itemlisttrans_H", rowHeader2 : "itemlisttrans_H", rowHeader3 : "itemlisttrans_H",
    //以下に貼り付け
    ISC: "itemlisttrans_I", ISN: "itemlisttrans_I", IMC: "itemlisttrans_I", IMN: "itemlisttrans_I", INM: "itemlisttrans_I", ICC: "itemlisttrans_I", ICN: "itemlisttrans_I", IBC: "itemlisttrans_I", IBN: "itemlisttrans_I", IJN: "itemlisttrans_I", ICD: "itemlisttrans_I", ICP: "itemlisttrans_I", IC1: "itemlisttrans_I", IC2: "itemlisttrans_I", ILI: "itemlisttrans_I", IPR: "itemlisttrans_I",
    TTL: "itemlisttrans_H",
    T01: "itemlisttrans_H", T02: "itemlisttrans_H", T03: "itemlisttrans_H", T04: "itemlisttrans_H", T05: "itemlisttrans_H", T06: "itemlisttrans_H", T07: "itemlisttrans_H", T08: "itemlisttrans_H", T09: "itemlisttrans_H", T10: "itemlisttrans_H",
    T11: "itemlisttrans_H", T12: "itemlisttrans_H", T13: "itemlisttrans_H", T14: "itemlisttrans_H", T15: "itemlisttrans_H", T16: "itemlisttrans_H", T17: "itemlisttrans_H", T18: "itemlisttrans_H", T19: "itemlisttrans_H", T20: "itemlisttrans_H",
    T21: "itemlisttrans_H", T22: "itemlisttrans_H", T23: "itemlisttrans_H", T24: "itemlisttrans_H", T25: "itemlisttrans_H", T26: "itemlisttrans_H", T27: "itemlisttrans_H", T28: "itemlisttrans_H", T29: "itemlisttrans_H", T30: "itemlisttrans_H",
    T31: "itemlisttrans_H",
  },
];
export const headerRowClasses = [
  {
    JJT: "itemlisttrans_J", JJP: "itemlisttrans_J", JJR: "itemlisttrans_J", JJD: "itemlisttrans_J", 
    JJQT: "itemlisttrans_J", JJQP: "itemlisttrans_J", JJQR: "itemlisttrans_J", JJQD: "itemlisttrans_J", 
    JKT: "itemlisttrans_K", JKP: "itemlisttrans_K", JKR: "itemlisttrans_K", JKD: "itemlisttrans_K", 
    JKQT: "itemlisttrans_K", JKQP: "itemlisttrans_K", JKQR: "itemlisttrans_K", JKQD: "itemlisttrans_K", 
    JRT: "itemlisttrans_K", JRP: "itemlisttrans_K", JRD: "itemlisttrans_K", 

    SHCT: "itemlisttrans_X", SHCP: "itemlisttrans_X", SHCR: "itemlisttrans_X", SHCD2: "itemlisttrans_X", 
    SHDT: "itemlisttrans_X", SHDP: "itemlisttrans_X", SHDR: "itemlisttrans_X", SHDD: "itemlisttrans_X", 
    SHRCT: "itemlisttrans_X", SHRCP: "itemlisttrans_X", SHRCR: "itemlisttrans_X", SHRCD: "itemlisttrans_X", 
    SHRDT: "itemlisttrans_X", SHRDP: "itemlisttrans_X", SHRDR: "itemlisttrans_X", SHRDD: "itemlisttrans_X", 
    SHT: "itemlisttrans_X", SHP: "itemlisttrans_X", SHR: "itemlisttrans_X", SHD: "itemlisttrans_X",

    //欠品責任別
    KI1KQ: "itemlisttrans_K2", KI1KA: "itemlisttrans_K2", KI1KR: "itemlisttrans_K2", 
    KI2KQ: "itemlisttrans_K2", KI2KA: "itemlisttrans_K2", KI2KR: "itemlisttrans_K2", 
    KI3KQ: "itemlisttrans_K2", KI3KA: "itemlisttrans_K2", KI3KR: "itemlisttrans_K2", 
    //欠品区分別
    K10KQ: "itemlisttrans_K2", K10KA: "itemlisttrans_K2", K10KR: "itemlisttrans_K2", 
    K11KQ: "itemlisttrans_K2", K11KA: "itemlisttrans_K2", K11KR: "itemlisttrans_K2", 
    K12KQ: "itemlisttrans_K2", K12KA: "itemlisttrans_K2", K12KR: "itemlisttrans_K2", 
    K13KQ: "itemlisttrans_K2", K13KA: "itemlisttrans_K2", K13KR: "itemlisttrans_K2", 
    K14KQ: "itemlisttrans_K2", K14KA: "itemlisttrans_K2", K14KR: "itemlisttrans_K2", 
    K15KQ: "itemlisttrans_K2", K15KA: "itemlisttrans_K2", K15KR: "itemlisttrans_K2", 
    K16KQ: "itemlisttrans_K2", K16KA: "itemlisttrans_K2", K16KR: "itemlisttrans_K2", 
    K17KQ: "itemlisttrans_K2", K17KA: "itemlisttrans_K2", K17KR: "itemlisttrans_K2", 
    K19KQ: "itemlisttrans_K2", K19KA: "itemlisttrans_K2", K19KR: "itemlisttrans_K2", 
    K20KQ: "itemlisttrans_K2", K20KA: "itemlisttrans_K2", K20KR: "itemlisttrans_K2", 
    K21KQ: "itemlisttrans_K2", K21KA: "itemlisttrans_K2", K21KR: "itemlisttrans_K2", 
    K22KQ: "itemlisttrans_K2", K22KA: "itemlisttrans_K2", K22KR: "itemlisttrans_K2", 
    K29KQ: "itemlisttrans_K2", K29KA: "itemlisttrans_K2", K29KR: "itemlisttrans_K2", 
    K30KQ: "itemlisttrans_K2", K30KA: "itemlisttrans_K2", K30KR: "itemlisttrans_K2", 
    K31KQ: "itemlisttrans_K2", K31KA: "itemlisttrans_K2", K31KR: "itemlisttrans_K2", 
    K32KQ: "itemlisttrans_K2", K32KA: "itemlisttrans_K2", K32KR: "itemlisttrans_K2", 
    K33KQ: "itemlisttrans_K2", K33KA: "itemlisttrans_K2", K33KR: "itemlisttrans_K2", 
    K41KQ: "itemlisttrans_K2", K41KA: "itemlisttrans_K2", K41KR: "itemlisttrans_K2", 
    K34KQ: "itemlisttrans_K2", K34KA: "itemlisttrans_K2", K34KR: "itemlisttrans_K2", 
    K39KQ: "itemlisttrans_K2", K39KA: "itemlisttrans_K2", K39KR: "itemlisttrans_K2", 
    K40KQ: "itemlisttrans_K2", K40KA: "itemlisttrans_K2", K40KR: "itemlisttrans_K2", 
    K42KQ: "itemlisttrans_K2", K42KA: "itemlisttrans_K2", K42KR: "itemlisttrans_K2", 
    K43KQ: "itemlisttrans_K2", K43KA: "itemlisttrans_K2", K43KR: "itemlisttrans_K2", 
    K44KQ: "itemlisttrans_K2", K44KA: "itemlisttrans_K2", K44KR: "itemlisttrans_K2", 
    K49KQ: "itemlisttrans_K2", K49KA: "itemlisttrans_K2", K49KR: "itemlisttrans_K2", 
    K50KQ: "itemlisttrans_K2", K50KA: "itemlisttrans_K2", K50KR: "itemlisttrans_K2", 
  },
  {
    JJT: "itemlisttrans_J", JJP: "itemlisttrans_J", JJR: "itemlisttrans_J", JJD: "itemlisttrans_J", 
    JJQT: "itemlisttrans_J", JJQP: "itemlisttrans_J", JJQR: "itemlisttrans_J", JJQD: "itemlisttrans_J", 
    JKT: "itemlisttrans_K", JKP: "itemlisttrans_K", JKR: "itemlisttrans_K", JKD: "itemlisttrans_K", 
    JKQT: "itemlisttrans_K", JKQP: "itemlisttrans_K", JKQR: "itemlisttrans_K", JKQD: "itemlisttrans_K", 
    JRT: "itemlisttrans_K", JRP: "itemlisttrans_K", JRD: "itemlisttrans_K", 

    SHCT: "itemlisttrans_X", SHCP: "itemlisttrans_X", SHCR: "itemlisttrans_X", SHCD2: "itemlisttrans_X", 
    SHDT: "itemlisttrans_X", SHDP: "itemlisttrans_X", SHDR: "itemlisttrans_X", SHDD: "itemlisttrans_X", 
    SHRCT: "itemlisttrans_X", SHRCP: "itemlisttrans_X", SHRCR: "itemlisttrans_X", SHRCD: "itemlisttrans_X", 
    SHRDT: "itemlisttrans_X", SHRDP: "itemlisttrans_X", SHRDR: "itemlisttrans_X", SHRDD: "itemlisttrans_X", 
    SHT: "itemlisttrans_X", SHP: "itemlisttrans_X", SHR: "itemlisttrans_X", SHD: "itemlisttrans_X",

    //欠品責任別
    KI1KQ: "itemlisttrans_K2", KI1KA: "itemlisttrans_K2", KI1KR: "itemlisttrans_K2", 
    KI2KQ: "itemlisttrans_K2", KI2KA: "itemlisttrans_K2", KI2KR: "itemlisttrans_K2", 
    KI3KQ: "itemlisttrans_K2", KI3KA: "itemlisttrans_K2", KI3KR: "itemlisttrans_K2", 
    //欠品区分別
    K10KQ: "itemlisttrans_K2", K10KA: "itemlisttrans_K2", K10KR: "itemlisttrans_K2", 
    K11KQ: "itemlisttrans_K2", K11KA: "itemlisttrans_K2", K11KR: "itemlisttrans_K2", 
    K12KQ: "itemlisttrans_K2", K12KA: "itemlisttrans_K2", K12KR: "itemlisttrans_K2", 
    K13KQ: "itemlisttrans_K2", K13KA: "itemlisttrans_K2", K13KR: "itemlisttrans_K2", 
    K14KQ: "itemlisttrans_K2", K14KA: "itemlisttrans_K2", K14KR: "itemlisttrans_K2", 
    K15KQ: "itemlisttrans_K2", K15KA: "itemlisttrans_K2", K15KR: "itemlisttrans_K2", 
    K16KQ: "itemlisttrans_K2", K16KA: "itemlisttrans_K2", K16KR: "itemlisttrans_K2", 
    K17KQ: "itemlisttrans_K2", K17KA: "itemlisttrans_K2", K17KR: "itemlisttrans_K2", 
    K19KQ: "itemlisttrans_K2", K19KA: "itemlisttrans_K2", K19KR: "itemlisttrans_K2", 
    K20KQ: "itemlisttrans_K2", K20KA: "itemlisttrans_K2", K20KR: "itemlisttrans_K2", 
    K21KQ: "itemlisttrans_K2", K21KA: "itemlisttrans_K2", K21KR: "itemlisttrans_K2", 
    K22KQ: "itemlisttrans_K2", K22KA: "itemlisttrans_K2", K22KR: "itemlisttrans_K2", 
    K29KQ: "itemlisttrans_K2", K29KA: "itemlisttrans_K2", K29KR: "itemlisttrans_K2", 
    K30KQ: "itemlisttrans_K2", K30KA: "itemlisttrans_K2", K30KR: "itemlisttrans_K2", 
    K31KQ: "itemlisttrans_K2", K31KA: "itemlisttrans_K2", K31KR: "itemlisttrans_K2", 
    K32KQ: "itemlisttrans_K2", K32KA: "itemlisttrans_K2", K32KR: "itemlisttrans_K2", 
    K33KQ: "itemlisttrans_K2", K33KA: "itemlisttrans_K2", K33KR: "itemlisttrans_K2", 
    K41KQ: "itemlisttrans_K2", K41KA: "itemlisttrans_K2", K41KR: "itemlisttrans_K2", 
    K34KQ: "itemlisttrans_K2", K34KA: "itemlisttrans_K2", K34KR: "itemlisttrans_K2", 
    K39KQ: "itemlisttrans_K2", K39KA: "itemlisttrans_K2", K39KR: "itemlisttrans_K2", 
    K40KQ: "itemlisttrans_K2", K40KA: "itemlisttrans_K2", K40KR: "itemlisttrans_K2", 
    K42KQ: "itemlisttrans_K2", K42KA: "itemlisttrans_K2", K42KR: "itemlisttrans_K2", 
    K43KQ: "itemlisttrans_K2", K43KA: "itemlisttrans_K2", K43KR: "itemlisttrans_K2", 
    K44KQ: "itemlisttrans_K2", K44KA: "itemlisttrans_K2", K44KR: "itemlisttrans_K2", 
    K49KQ: "itemlisttrans_K2", K49KA: "itemlisttrans_K2", K49KR: "itemlisttrans_K2", 
    K50KQ: "itemlisttrans_K2", K50KA: "itemlisttrans_K2", K50KR: "itemlisttrans_K2", 
  },
  {
    JJT: "itemlisttrans_J", JJP: "itemlisttrans_JP", JJR: "itemlisttrans_JP", JJD: "itemlisttrans_JP", 
    JJQT: "itemlisttrans_J", JJQP: "itemlisttrans_JP", JJQR: "itemlisttrans_JP", JJQD: "itemlisttrans_JP", 
    JKT: "itemlisttrans_K", JKP: "itemlisttrans_KP", JKR: "itemlisttrans_KP", JKD: "itemlisttrans_KP", 
    JKQT: "itemlisttrans_K", JKQP: "itemlisttrans_KP", JKQR: "itemlisttrans_KP", JKQD: "itemlisttrans_KP", 
    JRT: "itemlisttrans_K", JRP: "itemlisttrans_KP", JRD: "itemlisttrans_KP", 
    //欠品責任別
    KI1KQ: "itemlisttrans_K2", KI1KA: "itemlisttrans_K2", KI1KR: "itemlisttrans_K2", 
    KI2KQ: "itemlisttrans_K2", KI2KA: "itemlisttrans_K2", KI2KR: "itemlisttrans_K2", 
    KI3KQ: "itemlisttrans_K2", KI3KA: "itemlisttrans_K2", KI3KR: "itemlisttrans_K2", 
    //欠品区分別
    K10KQ: "itemlisttrans_K2", K10KA: "itemlisttrans_K2", K10KR: "itemlisttrans_K2", 
    K11KQ: "itemlisttrans_K2", K11KA: "itemlisttrans_K2", K11KR: "itemlisttrans_K2", 
    K12KQ: "itemlisttrans_K2", K12KA: "itemlisttrans_K2", K12KR: "itemlisttrans_K2", 
    K13KQ: "itemlisttrans_K2", K13KA: "itemlisttrans_K2", K13KR: "itemlisttrans_K2", 
    K14KQ: "itemlisttrans_K2", K14KA: "itemlisttrans_K2", K14KR: "itemlisttrans_K2", 
    K15KQ: "itemlisttrans_K2", K15KA: "itemlisttrans_K2", K15KR: "itemlisttrans_K2", 
    K16KQ: "itemlisttrans_K2", K16KA: "itemlisttrans_K2", K16KR: "itemlisttrans_K2", 
    K17KQ: "itemlisttrans_K2", K17KA: "itemlisttrans_K2", K17KR: "itemlisttrans_K2", 
    K19KQ: "itemlisttrans_K2", K19KA: "itemlisttrans_K2", K19KR: "itemlisttrans_K2", 
    K20KQ: "itemlisttrans_K2", K20KA: "itemlisttrans_K2", K20KR: "itemlisttrans_K2", 
    K21KQ: "itemlisttrans_K2", K21KA: "itemlisttrans_K2", K21KR: "itemlisttrans_K2", 
    K22KQ: "itemlisttrans_K2", K22KA: "itemlisttrans_K2", K22KR: "itemlisttrans_K2", 
    K29KQ: "itemlisttrans_K2", K29KA: "itemlisttrans_K2", K29KR: "itemlisttrans_K2", 
    K30KQ: "itemlisttrans_K2", K30KA: "itemlisttrans_K2", K30KR: "itemlisttrans_K2", 
    K31KQ: "itemlisttrans_K2", K31KA: "itemlisttrans_K2", K31KR: "itemlisttrans_K2", 
    K32KQ: "itemlisttrans_K2", K32KA: "itemlisttrans_K2", K32KR: "itemlisttrans_K2", 
    K33KQ: "itemlisttrans_K2", K33KA: "itemlisttrans_K2", K33KR: "itemlisttrans_K2", 
    K41KQ: "itemlisttrans_K2", K41KA: "itemlisttrans_K2", K41KR: "itemlisttrans_K2", 
    K34KQ: "itemlisttrans_K2", K34KA: "itemlisttrans_K2", K34KR: "itemlisttrans_K2", 
    K39KQ: "itemlisttrans_K2", K39KA: "itemlisttrans_K2", K39KR: "itemlisttrans_K2", 
    K40KQ: "itemlisttrans_K2", K40KA: "itemlisttrans_K2", K40KR: "itemlisttrans_K2", 
    K42KQ: "itemlisttrans_K2", K42KA: "itemlisttrans_K2", K42KR: "itemlisttrans_K2", 
    K43KQ: "itemlisttrans_K2", K43KA: "itemlisttrans_K2", K43KR: "itemlisttrans_K2", 
    K44KQ: "itemlisttrans_K2", K44KA: "itemlisttrans_K2", K44KR: "itemlisttrans_K2", 
    K49KQ: "itemlisttrans_K2", K49KA: "itemlisttrans_K2", K49KR: "itemlisttrans_K2", 
    K50KQ: "itemlisttrans_K2", K50KA: "itemlisttrans_K2", K50KR: "itemlisttrans_K2", 

    LQP: "itemlisttrans_P", LQR: "itemlisttrans_P", LQD: "itemlisttrans_P",
    DQP: "itemlisttrans_P", DQR: "itemlisttrans_P", DQD: "itemlisttrans_P",
    OQP: "itemlisttrans_P", OQR: "itemlisttrans_P", OQD: "itemlisttrans_P",
    ULP: "itemlisttrans_P", ULR: "itemlisttrans_P", ULD: "itemlisttrans_P",
    UDP: "itemlisttrans_P", UDR: "itemlisttrans_P", UDD: "itemlisttrans_P",
    UPP: "itemlisttrans_P", UPR: "itemlisttrans_P", UPD: "itemlisttrans_P",
    SQT: "itemlisttrans_P", SQP: "itemlisttrans_P", SQR: "itemlisttrans_P", SQD: "itemlisttrans_P",
    RQP: "itemlisttrans_P", RQR: "itemlisttrans_P", RQD: "itemlisttrans_P",
    WQP: "itemlisttrans_P", WQR: "itemlisttrans_P", WQD: "itemlisttrans_P",
    SLP: "itemlisttrans_P", SLR: "itemlisttrans_P", SLD: "itemlisttrans_P",
    SDP: "itemlisttrans_P", SDR: "itemlisttrans_P", SDD: "itemlisttrans_P",
    SRP: "itemlisttrans_P", SRR: "itemlisttrans_P", SRD: "itemlisttrans_P",
    STP: "itemlisttrans_P", STR: "itemlisttrans_P", STD: "itemlisttrans_P",
    PTP: "itemlisttrans_P", PTD: "itemlisttrans_P",
    PRP: "itemlisttrans_P", PRD: "itemlisttrans_P",
    CIP: "itemlisttrans_P", CIR: "itemlisttrans_P", CID: "itemlisttrans_P",
    CSP: "itemlisttrans_P", CSR: "itemlisttrans_P", CSD: "itemlisttrans_P",
    CTP: "itemlisttrans_P", CTR: "itemlisttrans_P", CTD: "itemlisttrans_P",
    BTP: "itemlisttrans_P", BTR: "itemlisttrans_P", BTD: "itemlisttrans_P",
    BRP: "itemlisttrans_P", BRD: "itemlisttrans_P",
    ATP: "itemlisttrans_P", ATR: "itemlisttrans_P", ATD: "itemlisttrans_P",
    ARP: "itemlisttrans_P", ARD: "itemlisttrans_P",
    SHCT: "itemlisttrans_X", SHCP: "itemlisttrans_X", SHCR: "itemlisttrans_X", SHCD2: "itemlisttrans_X", 
    SHDT: "itemlisttrans_X", SHDP: "itemlisttrans_X", SHDR: "itemlisttrans_X", SHDD: "itemlisttrans_X", 
    SHRCT: "itemlisttrans_X", SHRCP: "itemlisttrans_X", SHRCR: "itemlisttrans_X", SHRCD: "itemlisttrans_X", 
    SHRDT: "itemlisttrans_X", SHRDP: "itemlisttrans_X", SHRDR: "itemlisttrans_X", SHRDD: "itemlisttrans_X", 
    SHT: "itemlisttrans_X", SHP: "itemlisttrans_X", SHR: "itemlisttrans_X", SHD: "itemlisttrans_X",
  },
]

export const colWidths =
{
  no : 70,
  rowHeader1 : 100, rowHeader2 : 100, rowHeader3 : 100,
  //以下に貼り付け
  ISC: 80, ISN: 150, IMC: 80, IMN: 150, INM: 150, ICC: 80, ICN: 150, IBC: 80, IBN: 80,  IJN: 150, ICD: 100, ICP: 80, IC1: 80, IC2: 80, ILI: 80, IPR: 80,
  T01: 120, T02: 120, T03: 120, T04: 120, T05: 120, T06: 120, T07: 120, T08: 120, T09: 120, T10: 120,
  T11: 120, T12: 120, T13: 120, T14: 120, T15: 120, T16: 120, T17: 120, T18: 120, T19: 120, T20: 120,
  T21: 120, T22: 120, T23: 120, T24: 120, T25: 120, T26: 120, T27: 120, T28: 120, T29: 120, T30: 120,
  T31: 120,
  TTL: 120,
};

export const colDataType =
{
  no : {type: 'text', readOnly: true,},
  rowHeader1 : {type: 'text', readOnly: true,}, rowHeader2 : {type: 'text', readOnly: true,}, rowHeader3 : {type: 'text', readOnly: true,},
  //以下に貼り付け
  ISC: {type: 'text', readOnly: true,}, ISN: {type: 'text', readOnly: true,}, IMC: {type: 'text', readOnly: true,}, IMN: {type: 'text', readOnly: true,}, INM: {type: 'text', readOnly: true,}, ICC: {type: 'text', readOnly: true,}, ICN: {type: 'text', readOnly: true,}, IBC: {type: 'text', readOnly: true,}, IBN: {type: 'text', readOnly: true,}, IJN: {type: 'text', readOnly: true,}, ICD: {type: 'text', readOnly: true,}, ICP: {type: 'text', readOnly: true,}, 
  IC1: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},
  IC2: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},
  ILI: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0日',},},
  IPR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},
};

export const rowDataType =
{
  JJT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},  JJP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},  JJR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},},  JJD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},
  JJQT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},},  JJQP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},},  JJQR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},},  JJQD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},
  JST: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},  JSP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},  JSR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},},  JSD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},
  JSQT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},},  JSQP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},},  JSQR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},},  JSQD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},
  JKT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},},  JKP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},},  JKR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},},  JKD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},},
  JKQT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},},  JKQP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},},  JKQR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},},  JKQD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},},
  JRT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},},  JRP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},},  JRD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0.0P',},},
  //欠品責任別
  KI1KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, KI1KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, KI1KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  KI2KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, KI2KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, KI2KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  KI3KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, KI3KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, KI3KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  //欠品区分別
  K10KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K10KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K10KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K11KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K11KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K11KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K12KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K12KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K12KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K13KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K13KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K13KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K14KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K14KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K14KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K15KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K15KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K15KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K16KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K16KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K16KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K17KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K17KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K17KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K19KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K19KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K19KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K20KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K20KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K20KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K21KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K21KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K21KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K22KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K22KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K22KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K29KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K29KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K29KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K30KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K30KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K30KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K31KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K31KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K31KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K32KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K32KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K32KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K33KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K33KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K33KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K41KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K41KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K41KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K34KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K34KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K34KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K39KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K39KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K39KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K40KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K40KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K40KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K42KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K42KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K42KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K43KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K43KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K43KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K44KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K44KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K44KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K49KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K49KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K49KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 
  K50KQ: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0.0',},}, K50KA: {type: 'numeric', readOnly: true, numericFormat: {pattern: '△0,0',},}, K50KR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, 

  LQT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, LQP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, LQR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, LQD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, DQT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, DQP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, DQR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, DQD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, OQT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, OQP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, OQR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, OQD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, ULT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, ULP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, ULR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, ULD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, UDT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, UDP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, UDR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, UDD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, UPT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, UPP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, UPR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, UPD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, SQT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, SQP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, SQR: {type: 'numeric', readOnly: true, numericFormat: { pattern: '0.0%', }, }, SQD: {type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0.0', }, }, RQT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, RQP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, RQR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, RQD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, WQT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, WQP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},}, WQR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, WQD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0.0',},},
  SLT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, SLP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, SLR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, SLD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, SDT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, SDP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, SDR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, SDD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, SRT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, SRP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, SRR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, SRD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, STT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, STP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, STR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, STD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},
  PTT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, PTP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, PTD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, 
  PRT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.00%',},}, PRP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.00%',},}, PRD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.00P',},},
  CIT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, CIP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, CIR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, CID: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, CST: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, CSP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, CSR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, CSD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, CTT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, CTP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, CTR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, CTD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},},
  BTT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, BTP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, BTR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, BTD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, BRT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, BRP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, BRD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0P',},}, ATT: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, ATP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, ATR: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, ATD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0,0',},}, ART: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, ARP: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0%',},}, ARD: {type: 'numeric', readOnly: true, numericFormat: {pattern: '0.0P',},}, 
  SHCT: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, }, 
  SHCP: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, }, 
  SHCR: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0.0%', }, },
  SHCD2: { type: 'numeric', readOnly: true, numericFormat: { pattern: '△0,0', }, }, 
  SHDT: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, }, 
  SHDP: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, }, 
  SHDR: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0.0%', }, },
  SHDD: { type: 'numeric', readOnly: true, numericFormat: { pattern: '△0,0', }, }, 
  SHRCT: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, }, 
  SHRCP: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, }, 
  SHRCR: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0.0%', }, },
  SHRCD: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, }, 
  SHRDT: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, }, 
  SHRDP: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, }, 
  SHRDR: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0.0%', }, },
  SHRDD: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, },   
  SHT: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, },
  SHP: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0,0', }, },
  SHR: { type: 'numeric', readOnly: true, numericFormat: { pattern: '0.0%', }, },  
  SHD: { type: 'numeric', readOnly: true, numericFormat: { pattern: '△0,0', }, }, 
};

export const colRendererName =
{
  no : 'basicRenderer',
  rowHeader1 : 'basicRenderer', rowHeader2 : 'basicRenderer', rowHeader3 : 'basicRenderer',
  //以下に貼り付け
  ISC: 'basicRenderer', ISN: 'basicRenderer', IMC: 'basicRenderer', IMN: 'basicRenderer', INM: 'basicRenderer', ICC: 'basicRenderer', ICN: 'basicRenderer', IBC: 'basicRenderer', IBN: 'basicRenderer', IJN: 'basicRenderer', ICD: 'basicRenderer', ICP: 'basicRenderer', IC1: 'basicRenderer', IC2: 'basicRenderer', ILI: 'basicRenderer', IPR: 'basicRenderer',
  T01: 'basicRenderer', T02: 'basicRenderer', T03: 'basicRenderer', T04: 'basicRenderer', T05: 'basicRenderer', T06: 'basicRenderer', T07: 'basicRenderer', T08: 'basicRenderer', T09: 'basicRenderer', T10: 'basicRenderer',
  T11: 'basicRenderer', T12: 'basicRenderer', T13: 'basicRenderer', T14: 'basicRenderer', T15: 'basicRenderer', T16: 'basicRenderer', T17: 'basicRenderer', T18: 'basicRenderer', T19: 'basicRenderer', T20: 'basicRenderer',
  T21: 'basicRenderer', T22: 'basicRenderer', T23: 'basicRenderer', T24: 'basicRenderer', T25: 'basicRenderer', T26: 'basicRenderer', T27: 'basicRenderer', T28: 'basicRenderer', T29: 'basicRenderer', T30: 'basicRenderer',
  T31: 'basicRenderer',
  TTL: 'basicRenderer',
};

export const rowRendererName =
{
  JJT: 'basicRenderer', JJP: 'basicRenderer', JJR: 'basicRenderer', JJD: 'basicRenderer', 
  JJQT: 'basicRenderer', JJQP: 'basicRenderer', JJQR: 'basicRenderer', JJQD: 'basicRenderer', 
  JST: 'basicRenderer', JSP: 'basicRenderer', JSR: 'basicRenderer', JSD: 'basicRenderer', 
  JSQT: 'basicRenderer', JSQP: 'basicRenderer', JSQR: 'basicRenderer', JSQD: 'basicRenderer', 
  JKT: 'basicRenderer', JKP: 'basicRenderer', JKR: 'nebikiRateRenderer', JKD: 'basicRenderer', 
  JKQT: 'basicRenderer', JKQP: 'basicRenderer', JKQR: 'nebikiRateRenderer', JKQD: 'basicRenderer', 
  JRT: 'keppinRateRenderer', JRP: 'keppinRateRenderer', JRD: 'keppinRateDiffRenderer', 
  //欠品責任別
  KI1KQ: 'basicRenderer', KI1KA: 'basicRenderer', KI1KR: 'keppinRateRenderer', 
  KI2KQ: 'basicRenderer', KI2KA: 'basicRenderer', KI2KR: 'keppinRateRenderer', 
  KI3KQ: 'basicRenderer', KI3KA: 'basicRenderer', KI3KR: 'keppinRateRenderer', 
  //欠品区分別
  K10KQ: 'basicRenderer', K10KA: 'basicRenderer', K10KR: 'keppinRateRenderer', 
  K11KQ: 'basicRenderer', K11KA: 'basicRenderer', K11KR: 'keppinRateRenderer', 
  K12KQ: 'basicRenderer', K12KA: 'basicRenderer', K12KR: 'keppinRateRenderer', 
  K13KQ: 'basicRenderer', K13KA: 'basicRenderer', K13KR: 'keppinRateRenderer', 
  K14KQ: 'basicRenderer', K14KA: 'basicRenderer', K14KR: 'keppinRateRenderer', 
  K15KQ: 'basicRenderer', K15KA: 'basicRenderer', K15KR: 'keppinRateRenderer', 
  K16KQ: 'basicRenderer', K16KA: 'basicRenderer', K16KR: 'keppinRateRenderer', 
  K17KQ: 'basicRenderer', K17KA: 'basicRenderer', K17KR: 'keppinRateRenderer', 
  K19KQ: 'basicRenderer', K19KA: 'basicRenderer', K19KR: 'keppinRateRenderer', 
  K20KQ: 'basicRenderer', K20KA: 'basicRenderer', K20KR: 'keppinRateRenderer', 
  K21KQ: 'basicRenderer', K21KA: 'basicRenderer', K21KR: 'keppinRateRenderer', 
  K22KQ: 'basicRenderer', K22KA: 'basicRenderer', K22KR: 'keppinRateRenderer', 
  K29KQ: 'basicRenderer', K29KA: 'basicRenderer', K29KR: 'keppinRateRenderer', 
  K30KQ: 'basicRenderer', K30KA: 'basicRenderer', K30KR: 'keppinRateRenderer', 
  K31KQ: 'basicRenderer', K31KA: 'basicRenderer', K31KR: 'keppinRateRenderer', 
  K32KQ: 'basicRenderer', K32KA: 'basicRenderer', K32KR: 'keppinRateRenderer', 
  K33KQ: 'basicRenderer', K33KA: 'basicRenderer', K33KR: 'keppinRateRenderer', 
  K41KQ: 'basicRenderer', K41KA: 'basicRenderer', K41KR: 'keppinRateRenderer', 
  K34KQ: 'basicRenderer', K34KA: 'basicRenderer', K34KR: 'keppinRateRenderer', 
  K39KQ: 'basicRenderer', K39KA: 'basicRenderer', K39KR: 'keppinRateRenderer', 
  K40KQ: 'basicRenderer', K40KA: 'basicRenderer', K40KR: 'keppinRateRenderer', 
  K42KQ: 'basicRenderer', K42KA: 'basicRenderer', K42KR: 'keppinRateRenderer', 
  K43KQ: 'basicRenderer', K43KA: 'basicRenderer', K43KR: 'keppinRateRenderer', 
  K44KQ: 'basicRenderer', K44KA: 'basicRenderer', K44KR: 'keppinRateRenderer', 
  K49KQ: 'basicRenderer', K49KA: 'basicRenderer', K49KR: 'keppinRateRenderer', 
  K50KQ: 'basicRenderer', K50KA: 'basicRenderer', K50KR: 'keppinRateRenderer', 
  LQT: 'basicRenderer', LQP: 'basicRenderer', LQR: 'rateRenderer', LQD: 'basicRenderer', DQT: 'basicRenderer', DQP: 'basicRenderer', DQR: 'rateRenderer', DQD: 'basicRenderer', OQT: 'basicRenderer', OQP: 'basicRenderer', OQR: 'rateRenderer', OQD: 'basicRenderer', ULT: 'basicRenderer', ULP: 'basicRenderer', ULR: 'rateRenderer', ULD: 'basicRenderer', UDT: 'basicRenderer', UDP: 'basicRenderer', UDR: 'rateRenderer', UDD: 'basicRenderer', UPT: 'basicRenderer', UPP: 'basicRenderer', UPR: 'rateRenderer', UPD: 'basicRenderer', SQT: 'basicRenderer', SQP: 'basicRenderer', SQR: 'rateRenderer', SQD: 'basicRenderer', RQT: 'basicRenderer', RQP: 'basicRenderer', RQR: 'nebikiRateRenderer', RQD: 'basicRenderer', WQT: 'basicRenderer', WQP: 'basicRenderer', WQR: 'nebikiRateRenderer', WQD: 'basicRenderer',
  SLT: 'basicRenderer', SLP: 'basicRenderer', SLR: 'rateRenderer', SLD: 'basicRenderer', SDT: 'basicRenderer', SDP: 'basicRenderer', SDR: 'rateRenderer', SDD: 'basicRenderer', SRT: 'basicRenderer', SRP: 'basicRenderer', SRR: 'nebikiRateRenderer', SRD: 'basicRenderer', STT: 'basicRenderer', STP: 'basicRenderer', STR: 'rateRenderer', STD: 'basicRenderer',
  PTT: 'basicRenderer', PTP: 'basicRenderer', PTD: 'basicRenderer', PRT: 'basicRenderer', PRP: 'basicRenderer', PRD: 'basicRenderer',
  CIT: 'basicRenderer', CIP: 'basicRenderer', CIR: 'rateRenderer', CID: 'basicRenderer', CST: 'basicRenderer', CSP: 'basicRenderer', CSR: 'rateRenderer', CSD: 'basicRenderer', CTT: 'basicRenderer', CTP: 'basicRenderer', CTR: 'rateRenderer', CTD: 'basicRenderer',
  BTT: 'basicRenderer', BTP: 'basicRenderer', BTR: 'rateRenderer', BTD: 'basicRenderer', BRT: 'basicRenderer', BRP: 'basicRenderer', BRR: 'basicRenderer', BRD: 'basicRenderer', ATT: 'basicRenderer', ATP: 'basicRenderer', ATR: 'rateRenderer', ATD: 'basicRenderer', ART: 'basicRenderer', ARP: 'basicRenderer', ARR: 'basicRenderer', ARD: 'basicRenderer', 
  SHCT: 'basicRenderer', SHCP: 'basicRenderer', SHCR: 'nebikiRateRenderer', SHCD2: 'basicRenderer', 
  SHDT: 'basicRenderer', SHDP: 'basicRenderer', SHDR: 'nebikiRateRenderer', SHDD: 'basicRenderer', 
  SHRCT: 'basicRenderer', SHRCP: 'basicRenderer', SHRCR: 'rateRenderer', SHRCD: 'basicRenderer', 
  SHRDT: 'basicRenderer', SHRDP: 'basicRenderer', SHRDR: 'rateRenderer', SHRDD: 'basicRenderer', 
  SHT: 'basicRenderer', SHP: 'basicRenderer', SHR: 'nebikiRateRenderer', SHD: 'basicRenderer', 
};

//グラフ用
//barDataKeys : 前年, 予算, 本年
//lineDataKeys : 前年比, 達成率
export const chartDataKeys = [
  { barDataKeys: ["JJP", "", "JJT"], lineDataKeys: ["JJR"], rowKeys: ["JJT", "JJQT", "JJP", "JJQP", "JJR", "JJD", ] },
  { barDataKeys: ["JSP", "", "JST"], lineDataKeys: ["JSR"], rowKeys: ["JST", "JSQT", "JSP", "JSQP", "JSR", "JSD", ] },
  { barDataKeys: ["JKP", "", "JKT"], lineDataKeys: ["JKR"], rowKeys: ["JKT", "JKQT", "JKP", "JKQP", "JKR", "JKD", "JRT", "JRP", "JRD", ] },
  { barDataKeys: ["STP", "STB", "STT"], lineDataKeys: ["STR", "STBR"], rowKeys: ["SLT", "SLQT", "SLP", "SLQP", "SLR", "SLD", "SDT", "SDP", "SDR", "SDD", "SRT", "SRP", "SRR", "SRD", "STT", "STP", "STR", "STD", "STB", "STBR", "STBD",] },
  { barDataKeys: ["PTP", "PTB", "PTT"], lineDataKeys: ["PTBR"], rowKeys: ["PTT", "PTQT", "PTP", "PTQP", "PTR", "PTD", "PTB", "PTBR", "PTBD", "PRT", "PRP", "PRD",] },
  { barDataKeys: ["CTP", "CTB", "CTT"], lineDataKeys: ["CTR", "CTBR"], rowKeys: ["CIT", "CIQT", "CIP", "CIQP", "CIR", "CID", "CST", "CSP", "CSR", "CSD", "CTT", "CTP", "CTR", "CTD", "CTB", "CTBR", "CTBD",] },
  { barDataKeys: ["SHP", "", "SHT"], lineDataKeys: ["SHR"], rowKeys: ["SHCT", "SHCP", "SHCR", "SHCD2", "SHDT", "SHDP", "SHDR", "SHDD", "SHRCT", "SHRCP", "SHRCR", "SHRCD", "SHRDT", "SHRDP", "SHRDR", "SHRDD", "SHT", "SHP", "SHR", "SHD", ] },
  { barDataKeys: [], lineDataKeys: [], rowKeys: ["CCDT", "CCDQT", "CDDP", "CDDQP", "CDDR", "CDDD", "CDBT", "CDBP", "CDBR", "CDBD", "CDFT", "CDFP", "CDFR", "CDFD", "COCT", "COCP", "COCR", "COCD", "COPT", "COPP", "COPR", "COPD", "COET", "COEP", "COER", "COED", "CTPT", "CTPP", "CTPR", "CTPD", "CTST", "CTSP", "CTSR", "CTSD", "CTET", "CTEP", "CTER", "CTED",] },
];

//前年実績がマイナスの場合表示を変更する項目
export const preMinusList = [
  { cur: 'JJT', pre: 'JJP', key: 'JJR', },    //受注
  { cur: 'JST', pre: 'JSP', key: 'JSR', },    //売上
  { cur: 'JJQT', pre: 'JJQP', key: 'JJQR', },    //受注
  { cur: 'LQT', pre: 'LQP', key: 'LQR', },
  { cur: 'DQT', pre: 'DQP', key: 'DQR', },
  { cur: 'OQT', pre: 'OQP', key: 'OQR', },
  { cur: 'ULT', pre: 'ULP', key: 'ULR', },
  { cur: 'UDT', pre: 'UDP', key: 'UDR', },
  { cur: 'UPT', pre: 'UPP', key: 'UPR', },
  { cur: 'SQT', pre: 'SQP', key: 'SQR', },
  { cur: 'SLT', pre: 'SLP', key: 'SLR', },    //総売上配送売上
  { cur: 'SDT', pre: 'SDP', key: 'SDR', },    //総売上直送売上
  { cur: 'STT', pre: 'STP', key: 'STR', },    //総売上総売上
];
//前年実績がプラスの場合表示を変更する項目
export const prePlusList = [
  { cur: 'JKT', pre: 'JKP', key: 'JKR', },    //欠品
  { cur: 'JKQT', pre: 'JKQP', key: 'JKQR', },    //欠品
  { cur: 'RQT', pre: 'RQP', key: 'RQR', },
  { cur: 'WQT', pre: 'WQP', key: 'WQR', },
  { cur: 'SRT', pre: 'SRP', key: 'SRR', },    //総売上返品
];


//列定義情報（動的パラメータ）
interface ItemListTransColRowModelInterface {
  //列固定
  fixedColumnsLeft: number,

  //テーブルの各列のキー
  colKeys: string[],
  //テーブルの各行のキー
  // rowKeysMonthly: string[],
  rowKeysMonthlyQuick: string[];
  rowKeysMonthlyCommit: string[];
  rowKeysDaily: string[],
}

export class ItemListTransColRowModel implements ItemListTransColRowModelInterface {
  //列固定
  fixedColumnsLeft: number;
  //テーブルの各列のキー
  colKeys: string[];
  //テーブルの各列のキー
  // rowKeysMonthly: string[];
  rowKeysMonthlyQuick: string[];
  rowKeysMonthlyCommit: string[];
  rowKeysDaily: string[];
  //ヘッダー
  nestedHeaders; //any[][]
  //テーブルの各列の逆引き用マップ
  colKeysMap;
  //テーブルの各行の逆引き用マップ
  // rowKeysMonthlyMap;
  rowKeysMonthlyQuickMap;
  rowKeysMonthlyCommitMap;
  rowKeysDailyMap;

  constructor(param: ItemListTransColRowModelInterface) {
    this.fixedColumnsLeft = param.fixedColumnsLeft;
    this.colKeys = param.colKeys;
    // this.rowKeysMonthly = param.rowKeysMonthly;
    this.rowKeysMonthlyQuick = param.rowKeysMonthlyQuick;
    this.rowKeysMonthlyCommit = param.rowKeysMonthlyCommit;
    this.rowKeysDaily = param.rowKeysDaily;

    //テーブルの各列のキー逆引き
    const colKeysMap = {};
    param.colKeys.forEach((colKey, index) => {
      colKeysMap[colKey] = index;
    });
    this.colKeysMap = colKeysMap;
    //テーブルの各行のキー逆引き
    // const rowKeysMonthlyMap = {};
    const rowKeysMonthlyQuickMap = {};
    const rowKeysMonthlyCommitMap = {};
    const rowKeysDailyMap = {};
    // param.rowKeysMonthly.forEach((rowKey, index) => {
    //   rowKeysMonthlyMap[rowKey] = index;
    // });
    param.rowKeysMonthlyQuick.forEach((rowKey, index) => {
      rowKeysMonthlyQuickMap[rowKey] = index;
    });
    param.rowKeysMonthlyCommit.forEach((rowKey, index) => {
      rowKeysMonthlyCommitMap[rowKey] = index;
    });
    param.rowKeysDaily.forEach((rowKey, index) => {
      rowKeysDailyMap[rowKey] = index;
    });
    // this.rowKeysMonthlyMap = rowKeysMonthlyMap;
    this.rowKeysMonthlyQuickMap = rowKeysMonthlyQuickMap;
    this.rowKeysMonthlyCommitMap = rowKeysMonthlyCommitMap;
    this.rowKeysDailyMap = rowKeysDailyMap;

    //nestedHeaders初期化
    this.initNestedHeaders();
  }

  //nestedHeaders初期化
  initNestedHeaders() {
    //nestedHeaders
    const nestedHeaders = [];
    // const customBorders = [];
    headersCol.forEach((header, index) => {
      const lastHeader = index == headersCol.length - 1;
      const nestedHeader = [];

      let colspan=0;
      let preHeaderVal = null;
      this.colKeys.forEach((colKey) => {
        const headerVal = header[colKey];
        if(lastHeader) {
          nestedHeader.push(headerVal);
        }
        else {
          if(preHeaderVal !== null && preHeaderVal != headerVal){
            nestedHeader.push(colspan == 1 ? preHeaderVal : {label: preHeaderVal, colspan: colspan});
            colspan=0;
          }
          colspan++;
          preHeaderVal = headerVal;
        }
      });
      if(!lastHeader && colspan > 0) {
        nestedHeader.push(colspan == 1 ? preHeaderVal : {label: preHeaderVal, colspan: colspan});
      }

      nestedHeaders.push(nestedHeader);
    });

    this.nestedHeaders = nestedHeaders;
  }

  //function
  keyFromCol(column:number):string {
    return this.colKeys[column];
  }
  keyFromCols(columns:number[]):string[] {
    const vals:string[] = [];
    columns.forEach(column => vals.push(this.colKeys[column]))
    return vals;
  }
  colFromKey(colKey:string):number {
    return this.colKeysMap[colKey];
  }
  colFromKeys(colKeys:string[]):number[] {
    const vals:number[] = [];
    // colKeys.forEach(colKey => vals.push(this.colKeysMap[colKey]))
    colKeys.forEach(colKey => {if(this.colKeysMap[colKey]) vals.push(this.colKeysMap[colKey])});
    return vals;
  }
  //function
  keyFromRow(row:number, dataType:"daily" | "quick" | "commit" | null):string {
    const rowKeys = dataType == "quick" ? this.rowKeysMonthlyQuick : dataType == "commit" ? this.rowKeysMonthlyCommit : dataType == "daily" ? this.rowKeysDaily : [];
    return rowKeys[row];
  }
  keyFromRows(rows:number[], dataType:"daily" | "quick" | "commit" | null):string[] {
    const rowKeys = dataType == "quick" ? this.rowKeysMonthlyQuick : dataType == "commit" ? this.rowKeysMonthlyCommit : dataType == "daily" ? this.rowKeysDaily : [];
    const vals:string[] = [];
    rows.forEach(row => vals.push(rowKeys[row]))
    return vals;
  }
  rowFromKey(rowKey:string, dataType:"daily" | "quick" | "commit" | null):number {
    const rowKeysMap = dataType == "quick" ? this.rowKeysMonthlyQuickMap : dataType == "commit" ? this.rowKeysMonthlyCommitMap : dataType == "daily" ? this.rowKeysDailyMap : {};
    return rowKeysMap[rowKey];
  }
  rowFromKeys(rowKeys:string[], dataType:"daily" | "quick" | "commit" | null):number[] {
    const rowKeysMap = dataType == "quick" ? this.rowKeysMonthlyQuickMap : dataType == "commit" ? this.rowKeysMonthlyCommitMap : dataType == "daily" ? this.rowKeysDailyMap : {};
    const vals:number[] = [];
    rowKeys.forEach(rowKey => vals.push(rowKeysMap[rowKey]))
    return vals;
  }
}

//仕入実績
export const rowKeysShiire: string[] = [
  "SHCT", "SHCP", "SHCR", "SHCD2", 
  "SHDT", "SHDP", "SHDR", "SHDD", 
  "SHRCT", "SHRCP", "SHRCR", "SHRCD", 
  "SHRDT", "SHRDP", "SHRDR", "SHRDD", 
  "SHT", "SHP", "SHR", "SHD",
];

//ItemListTrans用の列モデル
export const itemListTransColRowModelDefault:ItemListTransColRowModel = new ItemListTransColRowModel({
  //列固定
  fixedColumnsLeft: 20,

  //テーブルの各列のキー
  colKeys: [
    "no",
    //以下に貼り付け
    "ISC", "ISN", "IMC", "IMN", "INM", "ICC", "ICN", "IBC", "IBN", "IJN", "ICD", "ICP", "IC1", "IC2", "ILI", "IPR",
    "rowHeader1", "rowHeader2", "rowHeader3",
    "TTL",
    "T01", "T02", "T03", "T04", "T05", "T06", "T07", "T08", "T09", "T10",
    "T11", "T12", "T13", "T14", "T15", "T16", "T17", "T18", "T19", "T20",
    "T21", "T22", "T23", "T24", "T25", "T26", "T27", "T28", "T29", "T30",
    "T31", 
  ],
  //テーブルの各行のキー
  rowKeysMonthlyQuick: [
    "JJQT", "JJQP", "JJQR", "JJQD",
    "JJT", "JJP", "JJR", "JJD",

    "LQT", "LQP", "LQR", "LQD", "DQT", "DQP", "DQR", "DQD", "OQT", "OQP", "OQR", "OQD", "ULT", "ULP", "ULR", "ULD", "UDT", "UDP", "UDR", "UDD", "UPT", "UPP", "UPR", "UPD", "SQT", "SQP", "SQR", "SQD", "RQT", "RQP", "RQR", "RQD", "WQT", "WQP", "WQR", "WQD",
    "SLT", "SLP", "SLR", "SLD", "SDT", "SDP", "SDR", "SDD", "SRT", "SRP", "SRR", "SRD", "STT", "STP", "STR", "STD",
    "PTT", "PTP", "PTD", "PRT", "PRP", "PRD",

    "JKQT", "JKQP", "JKQR", "JKQD",
    "JKT", "JKP", "JKR", "JKD",
    "JRT", "JRP", "JRD", 
    //欠品責任別
    "KI1KQ", "KI1KA", "KI1KR",
    "KI2KQ", "KI2KA", "KI2KR",
    "KI3KQ", "KI3KA", "KI3KR",

    "CIT", "CIP", "CIR", "CID", "CST", "CSP", "CSR", "CSD", "CTT", "CTP", "CTR", "CTD",
    "BTT", "BTP", "BTR", "BTD", "BRT", "BRP", "BRD", "ATT", "ATP", "ATR", "ATD", "ART", "ARP", "ARD",

    ...rowKeysShiire,

    //欠品区分別
    "K10KQ", "K10KA", "K10KR",
    "K11KQ", "K11KA", "K11KR",
    "K12KQ", "K12KA", "K12KR",
    // "K13KQ", "K13KA", "K13KR",
    "K14KQ", "K14KA", "K14KR",
    "K15KQ", "K15KA", "K15KR",
    "K16KQ", "K16KA", "K16KR",
    "K17KQ", "K17KA", "K17KR",
    "K19KQ", "K19KA", "K19KR",
    
    "K20KQ", "K20KA", "K20KR",
    "K21KQ", "K21KA", "K21KR",
    "K22KQ", "K22KA", "K22KR",
    "K29KQ", "K29KA", "K29KR",

    "K30KQ", "K30KA", "K30KR",
    "K31KQ", "K31KA", "K31KR",
    // "K32KQ", "K32KA", "K32KR",
    // "K33KQ", "K33KA", "K33KR",
    "K34KQ", "K34KA", "K34KR",
    // "K39KQ", "K39KA", "K39KR",
    "K40KQ", "K40KA", "K40KR",
    "K41KQ", "K41KA", "K41KR",
    "K42KQ", "K42KA", "K42KR",
    "K43KQ", "K43KA", "K43KR",
    // "K44KQ", "K44KA", "K44KR",
    // "K49KQ", "K49KA", "K49KR",
    "K50KQ", "K50KA", "K50KR",
  ],
  rowKeysMonthlyCommit: [
    // "JJQT", "JJQP", "JJQR", "JJQD",
    // "JJT", "JJP", "JJR", "JJD",

    "LQT", "LQP", "LQR", "LQD", "DQT", "DQP", "DQR", "DQD", "OQT", "OQP", "OQR", "OQD", "ULT", "ULP", "ULR", "ULD", "UDT", "UDP", "UDR", "UDD", "UPT", "UPP", "UPR", "UPD", "SQT", "SQP", "SQR", "SQD", "RQT", "RQP", "RQR", "RQD", "WQT", "WQP", "WQR", "WQD",
    "SLT", "SLP", "SLR", "SLD", "SDT", "SDP", "SDR", "SDD", "SRT", "SRP", "SRR", "SRD", "STT", "STP", "STR", "STD",
    "PTT", "PTP", "PTD", "PRT", "PRP", "PRD",

    // "JKQT", "JKQP", "JKQR", "JKQD",
    // "JKT", "JKP", "JKR", "JKD",
    // "JRT", "JRP", "JRD", 

    "CIT", "CIP", "CIR", "CID", "CST", "CSP", "CSR", "CSD", "CTT", "CTP", "CTR", "CTD",
    "BTT", "BTP", "BTR", "BTD", "BRT", "BRP", "BRD", "ATT", "ATP", "ATR", "ATD", "ART", "ARP", "ARD",

    ...rowKeysShiire,

    // //欠品責任別
    // "KI1KQ", "KI1KA", "KI1KR",
    // "KI2KQ", "KI2KA", "KI2KR",
    // "KI3KQ", "KI3KA", "KI3KR",

    // //欠品区分別
    // "K10KQ", "K10KA", "K10KR",
    // "K11KQ", "K11KA", "K11KR",
    // "K12KQ", "K12KA", "K12KR",
    // // "K13KQ", "K13KA", "K13KR",
    // "K14KQ", "K14KA", "K14KR",
    // "K15KQ", "K15KA", "K15KR",
    // "K16KQ", "K16KA", "K16KR",
    // "K17KQ", "K17KA", "K17KR",
    // "K19KQ", "K19KA", "K19KR",

    // "K20KQ", "K20KA", "K20KR",
    // "K21KQ", "K21KA", "K21KR",
    // "K22KQ", "K22KA", "K22KR",
    // "K29KQ", "K29KA", "K29KR",

    // "K30KQ", "K30KA", "K30KR",
    // "K31KQ", "K31KA", "K31KR",
    // // "K32KQ", "K32KA", "K32KR",
    // // "K33KQ", "K33KA", "K33KR",
    // "K34KQ", "K34KA", "K34KR",
    // // "K39KQ", "K39KA", "K39KR",
    // "K40KQ", "K40KA", "K40KR",
    // "K41KQ", "K41KA", "K41KR",
    // "K42KQ", "K42KA", "K42KR",
    // "K43KQ", "K43KA", "K43KR",
    // // "K44KQ", "K44KA", "K44KR",
    // // "K49KQ", "K49KA", "K49KR",
    // "K50KQ", "K50KA", "K50KR",
  ],
  rowKeysDaily: [
    "JJQT", //"JJQP", "JJQR", "JJQD",
    "JJT", //"JJP", "JJR", "JJD",
    "JSQT", //"JSQP", "JSQR", "JSQD",
    "JST", //"JSP", "JSR", "JSD",

    "JKQT", //"JKQP", "JKQR", "JKQD",
    "JKT", //"JKP", "JKR", "JKD",
    "JRT", //"JRP", "JRD", 
    //欠品責任別
    "KI1KQ", "KI1KA", "KI1KR",
    "KI2KQ", "KI2KA", "KI2KR",
    "KI3KQ", "KI3KA", "KI3KR",

    //欠品区分別
    "K10KQ", "K10KA", "K10KR",
    "K11KQ", "K11KA", "K11KR",
    "K12KQ", "K12KA", "K12KR",
    // "K13KQ", "K13KA", "K13KR",
    "K14KQ", "K14KA", "K14KR",
    "K15KQ", "K15KA", "K15KR",
    "K16KQ", "K16KA", "K16KR",
    "K17KQ", "K17KA", "K17KR",
    "K19KQ", "K19KA", "K19KR",

    "K20KQ", "K20KA", "K20KR",
    "K21KQ", "K21KA", "K21KR",
    "K22KQ", "K22KA", "K22KR",
    "K29KQ", "K29KA", "K29KR",

    "K30KQ", "K30KA", "K30KR",
    "K31KQ", "K31KA", "K31KR",
    // "K32KQ", "K32KA", "K32KR",
    // "K33KQ", "K33KA", "K33KR",
    "K34KQ", "K34KA", "K34KR",
    // "K39KQ", "K39KA", "K39KR",
    "K40KQ", "K40KA", "K40KR",
    "K41KQ", "K41KA", "K41KR",
    "K42KQ", "K42KA", "K42KR",
    "K43KQ", "K43KA", "K43KR",
    // "K44KQ", "K44KA", "K44KR",
    // "K49KQ", "K49KA", "K49KR",
    "K50KQ", "K50KA", "K50KR",
  ],
});

